export const aboutTranslations = {
  en: {
    General: {
      title: "PurpleDoor Overview",
      content: [
        "PurpleDoor is a growth and transformation platform designed for Gen Z and Gen Alpha learners through structured learning, challenges, certifications, skill development, and measurable progress tracking.",
        "The platform encourages discipline, consistency, execution, digital capability, and future-ready skills needed in an AI-driven world.",
        "Students, parents, mentors, coordinators, institutions, and leadership teams work together within a unified ecosystem focused on real-world outcomes."
      ]
    },

    Student: {
      title: "PurpleDoor for Students",
      content: [
        "PurpleDoor helps students transform learning into action through challenges, certifications, projects, skill-building activities, and achievement tracking.",
        "Students can develop discipline, consistency, communication, creativity, leadership, problem-solving, and digital skills that extend beyond traditional academics.",
        "The platform rewards progress, encourages continuous improvement, and helps learners build a strong foundation for future education, careers, entrepreneurship, and lifelong growth."
      ]
    },

    Parent: {
      title: "PurpleDoor for Parents",
      content: [
        "PurpleDoor gives parents a clear view of their child's learning journey, participation, achievements, certifications, and skill-building activities.",
        "Parents can encourage consistent habits, celebrate milestones, monitor progress, and support long-term personal growth beyond traditional academics.",
        "The platform helps families prepare children for an AI-driven future by promoting responsibility, digital literacy, critical thinking, creativity, and lifelong learning."
      ]
    },

     LearningPartner: {
      title: "PurpleDoor for Mentors & Institutions",
      content: [
        "PurpleDoor enables learning ecosystems to guide, support, and transform student development through structured learning journeys, challenges, certifications, projects, and skill-building initiatives.",
        "Mentors and institutions gain visibility into participation, progress, achievements, and learner growth beyond traditional academic measures.",
        "The platform helps create measurable impact by combining guidance, accountability, execution, and future-ready skill development."
      ]
    },

    BusinessPartner: {
      title: "PurpleDoor for Coordinators & Directors",
      content: [
        "PurpleDoor provides operational and strategic visibility into learner engagement, program performance, certifications, growth trends, and transformation outcomes.",
        "Coordinators and directors can monitor activities, support stakeholders, evaluate effectiveness, identify improvement opportunities, and ensure successful execution.",
        "The platform enables informed decision-making while aligning organizational goals with future workforce and community development needs."
      ]
    },
  },
  hi: {
    General: {
      title: "PurpleDoor परिचय",
      content: [
        "PurpleDoor Gen Z और Gen Alpha शिक्षार्थियों के लिए एक विकास और परिवर्तन मंच है, जो संरचित शिक्षण, चुनौतियों, प्रमाणपत्रों, कौशल विकास और मापनीय प्रगति ट्रैकिंग पर आधारित है।",
        "यह मंच अनुशासन, निरंतरता, क्रियान्वयन, डिजिटल क्षमता और AI-आधारित भविष्य के लिए आवश्यक कौशलों को बढ़ावा देता है।",
        "छात्र, अभिभावक, मार्गदर्शक, समन्वयक, संस्थान और नेतृत्व टीम एक साझा पारिस्थितिकी तंत्र में मिलकर वास्तविक परिणामों पर कार्य करते हैं।"
      ]
    },

    Student: {
      title: "छात्रों के लिए PurpleDoor",
      content: [
        "PurpleDoor छात्रों को चुनौतियों, प्रमाणपत्रों, परियोजनाओं, कौशल-विकास गतिविधियों और उपलब्धि ट्रैकिंग के माध्यम से सीखने को क्रियान्वयन में बदलने में सहायता करता है।",
        "छात्र अनुशासन, निरंतरता, संवाद कौशल, रचनात्मकता, नेतृत्व, समस्या समाधान और डिजिटल कौशल विकसित कर सकते हैं।",
        "यह मंच प्रगति को पुरस्कृत करता है, निरंतर सुधार को प्रोत्साहित करता है और भविष्य की शिक्षा, करियर, उद्यमिता तथा आजीवन विकास की मजबूत नींव तैयार करता है।"
      ]
    },

    Parent: {
      title: "अभिभावकों के लिए PurpleDoor",
      content: [
        "PurpleDoor अभिभावकों को अपने बच्चे की सीखने की यात्रा, सहभागिता, उपलब्धियों, प्रमाणपत्रों और कौशल-विकास गतिविधियों का स्पष्ट दृश्य प्रदान करता है।",
        "अभिभावक अच्छी आदतों को प्रोत्साहित कर सकते हैं, उपलब्धियों का उत्सव मना सकते हैं, प्रगति की निगरानी कर सकते हैं और दीर्घकालिक विकास में सहयोग दे सकते हैं।",
        "यह मंच परिवारों को AI-आधारित भविष्य के लिए बच्चों को तैयार करने में सहायता करता है।"
      ]
    },

    LearningPartner: {
      title: "मार्गदर्शकों एवं संस्थानों के लिए PurpleDoor",
      content: [
        "PurpleDoor शिक्षण पारिस्थितिकी तंत्र को छात्रों के विकास का मार्गदर्शन, समर्थन और रूपांतरण करने में सक्षम बनाता है।",
        "मार्गदर्शक और संस्थान सहभागिता, प्रगति, उपलब्धियों और विकास की स्पष्ट जानकारी प्राप्त कर सकते हैं।",
        "यह मंच मार्गदर्शन, उत्तरदायित्व, क्रियान्वयन और भविष्य-उन्मुख कौशल विकास के माध्यम से प्रभावशाली परिणाम उत्पन्न करता है।"
      ]
    },

    BusinessPartner: {
      title: "समन्वयकों एवं निदेशकों के लिए PurpleDoor",
      content: [
        "PurpleDoor शिक्षार्थी सहभागिता, कार्यक्रम प्रदर्शन, प्रमाणपत्रों, विकास प्रवृत्तियों और परिवर्तन परिणामों की परिचालन तथा रणनीतिक जानकारी प्रदान करता है।",
        "समन्वयक और निदेशक गतिविधियों की निगरानी कर सकते हैं, हितधारकों का समर्थन कर सकते हैं और सुधार के अवसरों की पहचान कर सकते हैं।",
        "यह मंच डेटा-आधारित निर्णय लेने में सहायता करता है और संगठनात्मक लक्ष्यों को भविष्य की आवश्यकताओं से जोड़ता है।"
      ]
    }
  },

  bn: {
    General: {
      title: "PurpleDoor পরিচিতি",
      content: [
        "PurpleDoor হল Gen Z এবং Gen Alpha শিক্ষার্থীদের জন্য একটি উন্নয়ন ও রূপান্তর প্ল্যাটফর্ম, যা কাঠামোবদ্ধ শিক্ষা, চ্যালেঞ্জ, সার্টিফিকেশন, দক্ষতা উন্নয়ন এবং অগ্রগতি পর্যবেক্ষণের উপর ভিত্তি করে তৈরি।",
        "এই প্ল্যাটফর্ম শৃঙ্খলা, ধারাবাহিকতা, বাস্তবায়ন, ডিজিটাল সক্ষমতা এবং AI-চালিত ভবিষ্যতের জন্য প্রয়োজনীয় দক্ষতা গড়ে তুলতে সহায়তা করে।",
        "শিক্ষার্থী, অভিভাবক, মেন্টর, সমন্বয়কারী, প্রতিষ্ঠান এবং নেতৃত্ব দল একটি অভিন্ন পরিবেশে বাস্তব ফলাফল অর্জনের জন্য একসঙ্গে কাজ করে।"
      ]
    },

    Student: {
      title: "শিক্ষার্থীদের জন্য PurpleDoor",
      content: [
        "PurpleDoor শিক্ষার্থীদের শিক্ষা থেকে বাস্তব কর্মে রূপান্তর করতে সাহায্য করে বিভিন্ন চ্যালেঞ্জ, সার্টিফিকেশন, প্রকল্প এবং দক্ষতা উন্নয়ন কার্যক্রমের মাধ্যমে।",
        "শিক্ষার্থীরা শৃঙ্খলা, ধারাবাহিকতা, যোগাযোগ দক্ষতা, সৃজনশীলতা, নেতৃত্ব, সমস্যা সমাধান এবং ডিজিটাল দক্ষতা অর্জন করতে পারে।",
        "এই প্ল্যাটফর্ম অগ্রগতিকে উৎসাহিত করে এবং ভবিষ্যৎ শিক্ষা, কর্মজীবন ও উদ্যোক্তা হওয়ার জন্য শক্ত ভিত্তি তৈরি করে।"
      ]
    },

    Parent: {
      title: "অভিভাবকদের জন্য PurpleDoor",
      content: [
        "PurpleDoor অভিভাবকদের তাদের সন্তানের শিক্ষার অগ্রগতি, অংশগ্রহণ, অর্জন এবং দক্ষতা উন্নয়নের পরিষ্কার ধারণা দেয়।",
        "অভিভাবকরা ইতিবাচক অভ্যাস গড়ে তুলতে, সাফল্য উদযাপন করতে এবং দীর্ঘমেয়াদি উন্নয়নে সহায়তা করতে পারেন।",
        "এই প্ল্যাটফর্ম পরিবারকে AI-চালিত ভবিষ্যতের জন্য সন্তানদের প্রস্তুত করতে সহায়তা করে।"
      ]
    },

    LearningPartner: {
      title: "মেন্টর ও প্রতিষ্ঠানের জন্য PurpleDoor",
      content: [
        "PurpleDoor শিক্ষার্থীদের উন্নয়নে দিকনির্দেশনা, সহায়তা এবং রূপান্তরের সুযোগ প্রদান করে।",
        "মেন্টর এবং প্রতিষ্ঠান শিক্ষার্থীদের অংশগ্রহণ, অগ্রগতি ও অর্জন পর্যবেক্ষণ করতে পারে।",
        "এই প্ল্যাটফর্ম জবাবদিহিতা, দক্ষতা উন্নয়ন এবং বাস্তব ফলাফল অর্জনে সহায়ক।"
      ]
    },

    BusinessPartner: {
      title: "সমন্বয়কারী ও পরিচালকদের জন্য PurpleDoor",
      content: [
        "PurpleDoor শিক্ষার্থী সম্পৃক্ততা, কর্মসূচির কার্যকারিতা, সার্টিফিকেশন এবং উন্নয়নের অগ্রগতি সম্পর্কে কৌশলগত তথ্য প্রদান করে।",
        "সমন্বয়কারী ও পরিচালকরা কার্যক্রম পর্যবেক্ষণ, উন্নয়নের সুযোগ চিহ্নিত এবং সফল বাস্তবায়ন নিশ্চিত করতে পারেন।",
        "এই প্ল্যাটফর্ম তথ্যভিত্তিক সিদ্ধান্ত গ্রহণে সহায়তা করে।"
      ]
    }
  },

  mr: {
    General: {
      title: "PurpleDoor परिचय",
      content: [
        "PurpleDoor हे Gen Z आणि Gen Alpha विद्यार्थ्यांसाठी तयार केलेले विकास आणि परिवर्तन व्यासपीठ आहे, जे संरचित शिक्षण, आव्हाने, प्रमाणपत्रे, कौशल्य विकास आणि प्रगती मोजण्यावर आधारित आहे.",
        "हे व्यासपीठ शिस्त, सातत्य, अंमलबजावणी, डिजिटल क्षमता आणि AI-आधारित भविष्यासाठी आवश्यक कौशल्यांना प्रोत्साहन देते.",
        "विद्यार्थी, पालक, मार्गदर्शक, समन्वयक, संस्था आणि नेतृत्व संघ एकत्रितपणे वास्तविक परिणाम साध्य करण्यासाठी कार्य करतात."
      ]
    },

    Student: {
      title: "विद्यार्थ्यांसाठी PurpleDoor",
      content: [
        "PurpleDoor विद्यार्थ्यांना आव्हाने, प्रमाणपत्रे, प्रकल्प आणि कौशल्य विकास उपक्रमांद्वारे शिक्षणाचे कृतीत रूपांतर करण्यास मदत करते.",
        "विद्यार्थी शिस्त, सातत्य, संवाद कौशल्य, सर्जनशीलता, नेतृत्व, समस्या सोडवणे आणि डिजिटल कौशल्ये विकसित करू शकतात.",
        "हे व्यासपीठ प्रगतीला प्रोत्साहन देते आणि भविष्यातील शिक्षण, करिअर, उद्योजकता आणि आयुष्यभराच्या विकासासाठी मजबूत पाया तयार करते."
      ]
    },

    Parent: {
      title: "पालकांसाठी PurpleDoor",
      content: [
        "PurpleDoor पालकांना त्यांच्या मुलांच्या शिक्षण प्रवास, सहभाग, यश, प्रमाणपत्रे आणि कौशल्य विकासाची स्पष्ट माहिती देते.",
        "पालक चांगल्या सवयींना प्रोत्साहन देऊ शकतात, यश साजरे करू शकतात आणि दीर्घकालीन विकासाला पाठिंबा देऊ शकतात.",
        "हे व्यासपीठ कुटुंबांना मुलांना AI-आधारित भविष्यासाठी तयार करण्यास मदत करते."
      ]
    },

    LearningPartner: {
      title: "मार्गदर्शक आणि संस्थांसाठी PurpleDoor",
      content: [
        "PurpleDoor विद्यार्थ्यांच्या विकासासाठी मार्गदर्शन, समर्थन आणि परिवर्तन घडवून आणण्यास मदत करते.",
        "मार्गदर्शक आणि संस्था सहभाग, प्रगती आणि यश यांचे निरीक्षण करू शकतात.",
        "हे व्यासपीठ जबाबदारी, अंमलबजावणी आणि भविष्याभिमुख कौशल्य विकासाद्वारे प्रभावी परिणाम निर्माण करते."
      ]
    },

    BusinessPartner: {
      title: "समन्वयक आणि संचालकांसाठी PurpleDoor",
      content: [
        "PurpleDoor विद्यार्थ्यांचा सहभाग, कार्यक्रम कार्यक्षमता, प्रमाणपत्रे आणि विकास परिणाम याबद्दल धोरणात्मक माहिती प्रदान करते.",
        "समन्वयक आणि संचालक उपक्रमांचे निरीक्षण करू शकतात, सुधारणा संधी ओळखू शकतात आणि यशस्वी अंमलबजावणी सुनिश्चित करू शकतात.",
        "हे व्यासपीठ माहिती-आधारित निर्णय घेण्यास मदत करते."
      ]
    }
  },
  
  gu: {
    General: {
      title: "PurpleDoor પરિચય",
      content: [
        "PurpleDoor એ Gen Z અને Gen Alpha શીખનારાઓ માટે રચાયેલ વિકાસ અને પરિવર્તન પ્લેટફોર્મ છે, જે સંરચિત શિક્ષણ, પડકારો, પ્રમાણપત્રો, કૌશલ્ય વિકાસ અને માપી શકાય તેવી પ્રગતિ ટ્રેકિંગ પર આધારિત છે.",
        "આ પ્લેટફોર્મ શિસ્ત, સતતતા, અમલીકરણ, ડિજિટલ ક્ષમતા અને AI આધારિત ભવિષ્ય માટે જરૂરી કૌશલ્યોને પ્રોત્સાહન આપે છે.",
        "વિદ્યાર્થીઓ, માતા-પિતા, માર્ગદર્શકો, સંકલનકારો, સંસ્થાઓ અને નેતૃત્વ ટીમો એક જ ઇકોસિસ્ટમમાં મળીને વાસ્તવિક પરિણામો માટે કાર્ય કરે છે."
      ]
    },

    Student: {
      title: "વિદ્યાર્થીઓ માટે PurpleDoor",
      content: [
        "PurpleDoor વિદ્યાર્થીઓને પડકારો, પ્રમાણપત્રો, પ્રોજેક્ટ્સ, કૌશલ્ય વિકાસ પ્રવૃત્તિઓ અને સિદ્ધિઓના ટ્રેકિંગ દ્વારા શીખવાનું કાર્યમાં રૂપાંતરિત કરવામાં મદદ કરે છે.",
        "વિદ્યાર્થીઓ શિસ્ત, સતતતા, સંવાદ કૌશલ્ય, સર્જનાત્મકતા, નેતૃત્વ, સમસ્યા ઉકેલવાની ક્ષમતા અને ડિજિટલ કૌશલ્યો વિકસાવી શકે છે.",
        "આ પ્લેટફોર્મ પ્રગતિને પ્રોત્સાહિત કરે છે અને ભવિષ્યના શિક્ષણ, કારકિર્દી, ઉદ્યોગસાહસિકતા અને જીવનભરના વિકાસ માટે મજબૂત પાયો તૈયાર કરે છે."
      ]
    },

    Parent: {
      title: "માતા-પિતા માટે PurpleDoor",
      content: [
        "PurpleDoor માતા-પિતાને તેમના બાળકની શૈક્ષણિક યાત્રા, ભાગીદારી, સિદ્ધિઓ, પ્રમાણપત્રો અને કૌશલ્ય વિકાસ પ્રવૃત્તિઓનું સ્પષ્ટ દૃશ્ય આપે છે.",
        "માતા-પિતા સારી આદતોને પ્રોત્સાહિત કરી શકે છે, સિદ્ધિઓની ઉજવણી કરી શકે છે, પ્રગતિ પર નજર રાખી શકે છે અને લાંબા ગાળાના વિકાસમાં સહાય કરી શકે છે.",
        "આ પ્લેટફોર્મ પરિવારોને બાળકોને AI આધારિત ભવિષ્ય માટે તૈયાર કરવામાં મદદ કરે છે."
      ]
    },

    LearningPartner: {
      title: "માર્ગદર્શકો અને સંસ્થાઓ માટે PurpleDoor",
      content: [
        "PurpleDoor શૈક્ષણિક ઇકોસિસ્ટમને વિદ્યાર્થીઓના વિકાસને માર્ગદર્શન, સહાય અને પરિવર્તન આપવા સક્ષમ બનાવે છે.",
        "માર્ગદર્શકો અને સંસ્થાઓ ભાગીદારી, પ્રગતિ, સિદ્ધિઓ અને શીખનારાના વિકાસ વિશે સ્પષ્ટ માહિતી મેળવી શકે છે.",
        "આ પ્લેટફોર્મ માર્ગદર્શન, જવાબદારી, અમલીકરણ અને ભવિષ્યલક્ષી કૌશલ્ય વિકાસ દ્વારા અસરકારક પરિણામો સર્જે છે."
      ]
    },

    BusinessPartner: {
      title: "સંકલનકારો અને નિર્દેશકો માટે PurpleDoor",
      content: [
        "PurpleDoor શીખનારાની ભાગીદારી, કાર્યક્રમ પ્રદર્શન, પ્રમાણપત્રો, વિકાસ પ્રવાહો અને પરિવર્તન પરિણામોની કામગીરી અને વ્યૂહાત્મક માહિતી પ્રદાન કરે છે.",
        "સંકલનકારો અને નિર્દેશકો પ્રવૃત્તિઓનું નિરીક્ષણ કરી શકે છે, સુધારાની તકો ઓળખી શકે છે અને સફળ અમલીકરણ સુનિશ્ચિત કરી શકે છે.",
        "આ પ્લેટફોર્મ માહિતી આધારિત નિર્ણય લેવામાં મદદ કરે છે."
      ]
    }
  },

  ta: {
    General: {
      title: "PurpleDoor அறிமுகம்",
      content: [
        "PurpleDoor என்பது Gen Z மற்றும் Gen Alpha கற்றலாளர்களுக்காக உருவாக்கப்பட்ட வளர்ச்சி மற்றும் மாற்றத் தளமாகும். இது கட்டமைக்கப்பட்ட கற்றல், சவால்கள், சான்றிதழ்கள், திறன் மேம்பாடு மற்றும் முன்னேற்ற கண்காணிப்பை வழங்குகிறது.",
        "இந்த தளம் ஒழுக்கம், தொடர்ச்சியான முயற்சி, செயலாக்க திறன், டிஜிட்டல் திறன் மற்றும் AI சார்ந்த எதிர்காலத்திற்கு தேவையான திறன்களை ஊக்குவிக்கிறது.",
        "மாணவர்கள், பெற்றோர், வழிகாட்டிகள், ஒருங்கிணைப்பாளர்கள், நிறுவனங்கள் மற்றும் தலைமைத்துவ அணிகள் ஒன்றிணைந்து உண்மையான விளைவுகளை உருவாக்குகின்றனர்."
      ]
    },

    Student: {
      title: "மாணவர்களுக்கான PurpleDoor",
      content: [
        "PurpleDoor மாணவர்களுக்கு சவால்கள், சான்றிதழ்கள், திட்டங்கள், திறன் மேம்பாட்டு செயல்பாடுகள் மற்றும் சாதனை கண்காணிப்பின் மூலம் கற்றலை செயலாக்கமாக மாற்ற உதவுகிறது.",
        "மாணவர்கள் ஒழுக்கம், தொடர்ச்சி, தொடர்புத்திறன், படைப்பாற்றல், தலைமைத்துவம், பிரச்சினை தீர்க்கும் திறன் மற்றும் டிஜிட்டல் திறன்களை வளர்த்துக்கொள்ளலாம்.",
        "இந்த தளம் முன்னேற்றத்தை ஊக்குவித்து, எதிர்கால கல்வி, தொழில், தொழில் முனைவோர் பயணம் மற்றும் வாழ்நாள் முழுவதும் வளர்ச்சிக்கான அடித்தளத்தை அமைக்கிறது."
      ]
    },

    Parent: {
      title: "பெற்றோருக்கான PurpleDoor",
      content: [
        "PurpleDoor பெற்றோருக்கு தங்கள் குழந்தையின் கற்றல் பயணம், பங்கேற்பு, சாதனைகள், சான்றிதழ்கள் மற்றும் திறன் வளர்ச்சி நடவடிக்கைகள் பற்றிய தெளிவான பார்வையை வழங்குகிறது.",
        "பெற்றோர் நல்ல பழக்கங்களை ஊக்குவிக்கலாம், சாதனைகளை கொண்டாடலாம், முன்னேற்றத்தை கண்காணிக்கலாம் மற்றும் நீண்டகால வளர்ச்சிக்கு ஆதரவளிக்கலாம்.",
        "இந்த தளம் குடும்பங்களுக்கு குழந்தைகளை AI சார்ந்த எதிர்காலத்திற்கு தயாராக்க உதவுகிறது."
      ]
    },

    LearningPartner: {
      title: "வழிகாட்டிகள் மற்றும் நிறுவனங்களுக்கான PurpleDoor",
      content: [
        "PurpleDoor மாணவர் வளர்ச்சியை வழிநடத்தவும், ஆதரிக்கவும், மாற்றவும் கல்வி சூழலமைப்புகளை வலுப்படுத்துகிறது.",
        "வழிகாட்டிகள் மற்றும் நிறுவனங்கள் பங்கேற்பு, முன்னேற்றம், சாதனைகள் மற்றும் கற்றலாளர் வளர்ச்சியை கண்காணிக்க முடியும்.",
        "இந்த தளம் வழிகாட்டுதல், பொறுப்புணர்வு, செயலாக்கம் மற்றும் எதிர்காலத் திறன் வளர்ச்சியின் மூலம் அர்த்தமுள்ள தாக்கத்தை உருவாக்குகிறது."
      ]
    },

    BusinessPartner: {
      title: "ஒருங்கிணைப்பாளர்கள் மற்றும் இயக்குநர்களுக்கான PurpleDoor",
      content: [
        "PurpleDoor கற்றலாளர் ஈடுபாடு, திட்ட செயல்திறன், சான்றிதழ்கள், வளர்ச்சி போக்குகள் மற்றும் மாற்ற முடிவுகள் பற்றிய செயல்பாட்டு மற்றும் மூலோபாய தகவல்களை வழங்குகிறது.",
        "ஒருங்கிணைப்பாளர்கள் மற்றும் இயக்குநர்கள் செயல்பாடுகளை கண்காணித்து, மேம்பாட்டு வாய்ப்புகளை கண்டறிந்து, வெற்றிகரமான செயலாக்கத்தை உறுதிசெய்ய முடியும்.",
        "இந்த தளம் தரவின் அடிப்படையில் முடிவெடுக்க உதவுகிறது."
      ]
    }
  },

  te: {
    General: {
      title: "PurpleDoor పరిచయం",
      content: [
        "PurpleDoor అనేది Gen Z మరియు Gen Alpha అభ్యాసకుల కోసం రూపొందించబడిన అభివృద్ధి మరియు పరివర్తన వేదిక. ఇది నిర్మిత అభ్యాసం, సవాళ్లు, సర్టిఫికేషన్లు, నైపుణ్యాభివృద్ధి మరియు కొలవగల పురోగతి ట్రాకింగ్‌ను అందిస్తుంది.",
        "ఈ వేదిక క్రమశిక్షణ, స్థిరత్వం, అమలు సామర్థ్యం, డిజిటల్ సామర్థ్యం మరియు AI ఆధారిత భవిష్యత్తుకు అవసరమైన నైపుణ్యాలను ప్రోత్సహిస్తుంది.",
        "విద్యార్థులు, తల్లిదండ్రులు, మార్గదర్శకులు, సమన్వయకర్తలు, సంస్థలు మరియు నాయకత్వ బృందాలు కలిసి వాస్తవ ప్రపంచ ఫలితాల కోసం పనిచేస్తాయి."
      ]
    },

    Student: {
      title: "విద్యార్థుల కోసం PurpleDoor",
      content: [
        "PurpleDoor విద్యార్థులకు సవాళ్లు, సర్టిఫికేషన్లు, ప్రాజెక్టులు, నైపుణ్యాభివృద్ధి కార్యక్రమాలు మరియు విజయాల ట్రాకింగ్ ద్వారా అభ్యాసాన్ని కార్యరూపంలోకి మార్చడంలో సహాయపడుతుంది.",
        "విద్యార్థులు క్రమశిక్షణ, స్థిరత్వం, కమ్యూనికేషన్, సృజనాత్మకత, నాయకత్వం, సమస్య పరిష్కార సామర్థ్యం మరియు డిజిటల్ నైపుణ్యాలను అభివృద్ధి చేసుకోవచ్చు.",
        "ఈ వేదిక పురోగతిని ప్రోత్సహించి, భవిష్యత్ విద్య, కెరీర్, వ్యాపార ప్రారంభం మరియు జీవితాంత అభివృద్ధికి బలమైన పునాది వేస్తుంది."
      ]
    },

    Parent: {
      title: "తల్లిదండ్రుల కోసం PurpleDoor",
      content: [
        "PurpleDoor తల్లిదండ్రులకు తమ పిల్లల అభ్యాస ప్రయాణం, పాల్గొనడం, విజయాలు, సర్టిఫికేషన్లు మరియు నైపుణ్యాభివృద్ధి కార్యకలాపాలపై స్పష్టమైన అవగాహనను అందిస్తుంది.",
        "తల్లిదండ్రులు మంచి అలవాట్లను ప్రోత్సహించవచ్చు, విజయాలను జరుపుకోవచ్చు, పురోగతిని పర్యవేక్షించవచ్చు మరియు దీర్ఘకాలిక అభివృద్ధికి మద్దతు ఇవ్వవచ్చు.",
        "ఈ వేదిక కుటుంబాలు తమ పిల్లలను AI ఆధారిత భవిష్యత్తుకు సిద్ధం చేయడంలో సహాయపడుతుంది."
      ]
    },

    LearningPartner: {
      title: "మార్గదర్శకులు మరియు సంస్థల కోసం PurpleDoor",
      content: [
        "PurpleDoor విద్యార్థుల అభివృద్ధిని మార్గనిర్దేశం చేయడానికి, మద్దతు ఇవ్వడానికి మరియు రూపాంతరం చెందించడానికి విద్యా వ్యవస్థలను శక్తివంతం చేస్తుంది.",
        "మార్గదర్శకులు మరియు సంస్థలు పాల్గొనడం, పురోగతి, విజయాలు మరియు అభ్యాసకుల అభివృద్ధిపై స్పష్టమైన అవగాహన పొందగలవు.",
        "ఈ వేదిక మార్గనిర్దేశం, బాధ్యత, అమలు మరియు భవిష్యత్ నైపుణ్యాభివృద్ధి ద్వారా అర్థవంతమైన ఫలితాలను సృష్టిస్తుంది."
      ]
    },

    BusinessPartner: {
      title: "సమన్వయకర్తలు మరియు డైరెక్టర్ల కోసం PurpleDoor",
      content: [
        "PurpleDoor అభ్యాసకుల భాగస్వామ్యం, కార్యక్రమాల పనితీరు, సర్టిఫికేషన్లు, అభివృద్ధి ధోరణులు మరియు పరివర్తన ఫలితాలపై కార్యాచరణ మరియు వ్యూహాత్మక అవగాహనను అందిస్తుంది.",
        "సమన్వయకర్తలు మరియు డైరెక్టర్లు కార్యకలాపాలను పర్యవేక్షించవచ్చు, మెరుగుదల అవకాశాలను గుర్తించవచ్చు మరియు విజయవంతమైన అమలును నిర్ధారించవచ్చు.",
        "ఈ వేదిక డేటా ఆధారిత నిర్ణయాలను తీసుకోవడంలో సహాయపడుతుంది."
      ]
    }
  },

  kn: {
    General: {
      title: "PurpleDoor ಪರಿಚಯ",
      content: [
        "PurpleDoorವು Gen Z ಮತ್ತು Gen Alpha ಕಲಿಯುವವರಿಗಾಗಿ ರೂಪಿಸಲಾದ ಬೆಳವಣಿಗೆ ಮತ್ತು ಪರಿವರ್ತನೆ ವೇದಿಕೆಯಾಗಿದ್ದು, ಸಂರಚಿತ ಅಧ್ಯಯನ, ಸವಾಲುಗಳು, ಪ್ರಮಾಣಪತ್ರಗಳು, ಕೌಶಲ್ಯಾಭಿವೃದ್ಧಿ ಮತ್ತು ಅಳೆಯಬಹುದಾದ ಪ್ರಗತಿ ಟ್ರ್ಯಾಕಿಂಗ್‌ ಮೇಲೆ ಕೇಂದ್ರೀಕೃತವಾಗಿದೆ.",
        "ಈ ವೇದಿಕೆ AI ಆಧಾರಿತ ಜಗತ್ತಿನಲ್ಲಿ ಅಗತ್ಯವಾದ ಶಿಸ್ತು, ನಿರಂತರತೆ, ಕಾರ್ಯಗತಗೊಳಿಸುವಿಕೆ, ಡಿಜಿಟಲ್ ಸಾಮರ್ಥ್ಯ ಮತ್ತು ಭವಿಷ್ಯ-ಸಿದ್ಧ ಕೌಶಲ್ಯಗಳನ್ನು ಉತ್ತೇಜಿಸುತ್ತದೆ.",
        "ವಿದ್ಯಾರ್ಥಿಗಳು, ಪೋಷಕರು, ಮಾರ್ಗದರ್ಶಕರು, ಸಂಯೋಜಕರು, ಸಂಸ್ಥೆಗಳು ಮತ್ತು ನಾಯಕತ್ವ ತಂಡಗಳು ನೈಜ ಜೀವನದ ಫಲಿತಾಂಶಗಳ ಮೇಲೆ ಕೇಂದ್ರೀಕೃತವಾದ ಏಕೀಕೃತ ಪರಿಸರದಲ್ಲಿ ಒಟ್ಟಾಗಿ ಕೆಲಸ ಮಾಡುತ್ತಾರೆ."
      ]
    },

    Student: {
      title: "ವಿದ್ಯಾರ್ಥಿಗಳಿಗಾಗಿ PurpleDoor",
      content: [
        "PurpleDoorವು ಸವಾಲುಗಳು, ಪ್ರಮಾಣಪತ್ರಗಳು, ಯೋಜನೆಗಳು, ಕೌಶಲ್ಯಾಭಿವೃದ್ಧಿ ಚಟುವಟಿಕೆಗಳು ಮತ್ತು ಸಾಧನೆಗಳ ಟ್ರ್ಯಾಕಿಂಗ್ ಮೂಲಕ ಕಲಿಕೆಯನ್ನು ಕಾರ್ಯಗತಗೊಳಿಸುವಿಕೆಗೆ ಪರಿವರ್ತಿಸಲು ವಿದ್ಯಾರ್ಥಿಗಳಿಗೆ ಸಹಾಯ ಮಾಡುತ್ತದೆ.",
        "ವಿದ್ಯಾರ್ಥಿಗಳು ಶಿಸ್ತು, ನಿರಂತರತೆ, ಸಂವಹನ, ಸೃಜನಶೀಲತೆ, ನಾಯಕತ್ವ, ಸಮಸ್ಯೆ ಪರಿಹಾರ ಮತ್ತು ಡಿಜಿಟಲ್ ಕೌಶಲ್ಯಗಳನ್ನು ಅಭಿವೃದ್ಧಿಪಡಿಸಬಹುದು, ಅವು ಸಾಂಪ್ರದಾಯಿಕ ಶಿಕ್ಷಣವನ್ನು ಮೀರಿರುತ್ತವೆ.",
        "ಈ ವೇದಿಕೆ ಪ್ರಗತಿಯನ್ನು ಗುರುತಿಸುತ್ತದೆ, ನಿರಂತರ ಸುಧಾರಣೆಯನ್ನು ಉತ್ತೇಜಿಸುತ್ತದೆ ಮತ್ತು ಭವಿಷ್ಯದ ಶಿಕ್ಷಣ, ಉದ್ಯೋಗ, ಉದ್ಯಮಶೀಲತೆ ಮತ್ತು ಜೀವನಪರ್ಯಂತ ಬೆಳವಣಿಗೆಗೆ ಬಲವಾದ ಅಡಿಪಾಯ ನಿರ್ಮಿಸಲು ಸಹಾಯ ಮಾಡುತ್ತದೆ."
      ]
    },

    Parent: {
      title: "ಪೋಷಕರಿಗಾಗಿ PurpleDoor",
      content: [
        "PurpleDoorವು ಪೋಷಕರಿಗೆ ತಮ್ಮ ಮಕ್ಕಳ ಕಲಿಕಾ ಪಯಣ, ಭಾಗವಹಿಸುವಿಕೆ, ಸಾಧನೆಗಳು, ಪ್ರಮಾಣಪತ್ರಗಳು ಮತ್ತು ಕೌಶಲ್ಯಾಭಿವೃದ್ಧಿ ಚಟುವಟಿಕೆಗಳ ಸ್ಪಷ್ಟ ಚಿತ್ರಣವನ್ನು ಒದಗಿಸುತ್ತದೆ.",
        "ಪೋಷಕರು ಉತ್ತಮ ಅಭ್ಯಾಸಗಳನ್ನು ಉತ್ತೇಜಿಸಬಹುದು, ಮೈಲುಗಲ್ಲುಗಳನ್ನು ಸಂಭ್ರಮಿಸಬಹುದು, ಪ್ರಗತಿಯನ್ನು ಗಮನಿಸಬಹುದು ಮತ್ತು ಸಾಂಪ್ರದಾಯಿಕ ಶಿಕ್ಷಣದಾಚೆಯ ವೈಯಕ್ತಿಕ ಬೆಳವಣಿಗೆಯನ್ನು ಬೆಂಬಲಿಸಬಹುದು.",
        "ಈ ವೇದಿಕೆ ಹೊಣೆಗಾರಿಕೆ, ಡಿಜಿಟಲ್ ಸಾಕ್ಷರತೆ, ವಿಮರ್ಶಾತ್ಮಕ ಚಿಂತನೆ, ಸೃಜನಶೀಲತೆ ಮತ್ತು ಜೀವನಪರ್ಯಂತ ಕಲಿಕೆಯನ್ನು ಉತ್ತೇಜಿಸುವ ಮೂಲಕ ಕುಟುಂಬಗಳಿಗೆ AI-ಆಧಾರಿತ ಭವಿಷ್ಯಕ್ಕೆ ಮಕ್ಕಳನ್ನು ಸಿದ್ಧಗೊಳಿಸಲು ಸಹಾಯ ಮಾಡುತ್ತದೆ."
      ]
    },

    LearningPartner: {
      title: "ಮಾರ್ಗದರ್ಶಕರು ಮತ್ತು ಸಂಸ್ಥೆಗಳಿಗಾಗಿ PurpleDoor",
      content: [
        "PurpleDoorವು ಸಂರಚಿತ ಕಲಿಕಾ ಪಯಣಗಳು, ಸವಾಲುಗಳು, ಪ್ರಮಾಣಪತ್ರಗಳು, ಯೋಜನೆಗಳು ಮತ್ತು ಕೌಶಲ್ಯಾಭಿವೃದ್ಧಿ ಕಾರ್ಯಕ್ರಮಗಳ ಮೂಲಕ ವಿದ್ಯಾರ್ಥಿಗಳ ಬೆಳವಣಿಗೆಯನ್ನು ಮಾರ್ಗದರ್ಶನ ಮಾಡಲು, ಬೆಂಬಲಿಸಲು ಮತ್ತು ರೂಪಾಂತರಗೊಳಿಸಲು ಸಹಾಯ ಮಾಡುತ್ತದೆ.",
        "ಮಾರ್ಗದರ್ಶಕರು ಮತ್ತು ಸಂಸ್ಥೆಗಳು ಭಾಗವಹಿಸುವಿಕೆ, ಪ್ರಗತಿ, ಸಾಧನೆಗಳು ಮತ್ತು ಕಲಿಯುವವರ ಬೆಳವಣಿಗೆಯ ಕುರಿತು ಸಾಂಪ್ರದಾಯಿಕ ಶೈಕ್ಷಣಿಕ ಅಳತೆಗಳಿಗಿಂತ ಹೆಚ್ಚಿನ ದೃಷ್ಟಿಯನ್ನು ಪಡೆಯುತ್ತಾರೆ.",
        "ಈ ವೇದಿಕೆ ಮಾರ್ಗದರ್ಶನ, ಹೊಣೆಗಾರಿಕೆ, ಕಾರ್ಯಗತಗೊಳಿಸುವಿಕೆ ಮತ್ತು ಭವಿಷ್ಯ-ಸಿದ್ಧ ಕೌಶಲ್ಯಾಭಿವೃದ್ಧಿಯನ್ನು ಒಟ್ಟುಗೂಡಿಸುವ ಮೂಲಕ ಅಳೆಯಬಹುದಾದ ಪರಿಣಾಮವನ್ನು ಸೃಷ್ಟಿಸಲು ಸಹಾಯ ಮಾಡುತ್ತದೆ."
      ]
    },

    BusinessPartner: {
      title: "ಸಂಯೋಜಕರು ಮತ್ತು ನಿರ್ದೇಶಕರಿಗಾಗಿ PurpleDoor",
      content: [
        "PurpleDoorವು ಕಲಿಯುವವರ ತೊಡಗಿಸಿಕೊಳ್ಳುವಿಕೆ, ಕಾರ್ಯಕ್ರಮದ ಕಾರ್ಯಕ್ಷಮತೆ, ಪ್ರಮಾಣಪತ್ರಗಳು, ಬೆಳವಣಿಗೆ ಪ್ರವೃತ್ತಿಗಳು ಮತ್ತು ಪರಿವರ್ತನಾ ಫಲಿತಾಂಶಗಳ ಕುರಿತು ಕಾರ್ಯಾಚರಣಾತ್ಮಕ ಮತ್ತು ತಂತ್ರಾತ್ಮಕ ದೃಷ್ಟಿಯನ್ನು ಒದಗಿಸುತ್ತದೆ.",
        "ಸಂಯೋಜಕರು ಮತ್ತು ನಿರ್ದೇಶಕರು ಚಟುವಟಿಕೆಗಳನ್ನು ಮೇಲ್ವಿಚಾರಣೆ ಮಾಡಬಹುದು, ಹಿತಾಸಕ್ತಿದಾರರಿಗೆ ಬೆಂಬಲ ನೀಡಬಹುದು, ಪರಿಣಾಮಕಾರಿತ್ವವನ್ನು ಮೌಲ್ಯಮಾಪನ ಮಾಡಬಹುದು, ಸುಧಾರಣೆಯ ಅವಕಾಶಗಳನ್ನು ಗುರುತಿಸಬಹುದು ಮತ್ತು ಯಶಸ್ವಿ ಕಾರ್ಯಗತಗೊಳಿಸುವಿಕೆಯನ್ನು ಖಚಿತಪಡಿಸಬಹುದು.",
        "ಈ ವೇದಿಕೆ ಭವಿಷ್ಯದ ಉದ್ಯೋಗಶಕ್ತಿ ಮತ್ತು ಸಮುದಾಯ ಅಭಿವೃದ್ಧಿ ಅಗತ್ಯಗಳಿಗೆ ಹೊಂದಿಕೊಳ್ಳುವ ರೀತಿಯಲ್ಲಿ ಮಾಹಿತಿ ಆಧಾರಿತ ನಿರ್ಧಾರಗಳನ್ನು ಕೈಗೊಳ್ಳಲು ಸಹಾಯ ಮಾಡುತ್ತದೆ."
      ]
    }
  },

  ml: {
    General: {
      title: "PurpleDoor അവലോകനം",
      content: [
        "Gen Z, Gen Alpha പഠിതാക്കൾക്കായി രൂപകൽപ്പന ചെയ്ത വളർച്ചയും പരിവർത്തനവും ലക്ഷ്യമാക്കുന്ന പ്ലാറ്റ്ഫോമാണ് PurpleDoor. ഘടനാപരമായ പഠനം, ചലഞ്ചുകൾ, സർട്ടിഫിക്കേഷനുകൾ, കഴിവ് വികസനം, അളക്കാവുന്ന പുരോഗതി എന്നിവ ഇതിന്റെ പ്രധാന ഭാഗങ്ങളാണ്.",
        "AI അധിഷ്ഠിത ലോകത്തിൽ ആവശ്യമായ ശാസ്ത്രീയ ശീലം, സ്ഥിരത, നിർവഹണ കഴിവ്, ഡിജിറ്റൽ ശേഷി, ഭാവി സജ്ജമായ കഴിവുകൾ എന്നിവയെ ഈ പ്ലാറ്റ്ഫോം പ്രോത്സാഹിപ്പിക്കുന്നു.",
        "വിദ്യാർത്ഥികൾ, മാതാപിതാക്കൾ, മെന്റർമാർ, കോർഡിനേറ്റർമാർ, സ്ഥാപനങ്ങൾ, നേതൃസംഘങ്ങൾ എന്നിവർ യഥാർത്ഥ ജീവിത ഫലങ്ങൾ ലക്ഷ്യമാക്കി ഒരുമിച്ച് പ്രവർത്തിക്കുന്നു."
      ]
    },

    Student: {
      title: "വിദ്യാർത്ഥികൾക്കായുള്ള PurpleDoor",
      content: [
        "ചലഞ്ചുകൾ, സർട്ടിഫിക്കേഷനുകൾ, പ്രോജക്ടുകൾ, കഴിവ് വികസന പ്രവർത്തനങ്ങൾ, നേട്ടങ്ങളുടെ ട്രാക്കിംഗ് എന്നിവയിലൂടെ പഠനത്തെ പ്രവർത്തിയാക്കി മാറ്റാൻ PurpleDoor വിദ്യാർത്ഥികളെ സഹായിക്കുന്നു.",
        "വിദ്യാർത്ഥികൾക്ക് ശാസ്ത്രീയ ശീലം, സ്ഥിരത, ആശയവിനിമയം, സൃഷ്ടിപരത, നേതൃപാടവം, പ്രശ്നപരിഹാര കഴിവ്, ഡിജിറ്റൽ നൈപുണ്യം എന്നിവ വികസിപ്പിക്കാം.",
        "പ്ലാറ്റ്ഫോം പുരോഗതിയെ അംഗീകരിക്കുകയും തുടർച്ചയായ മെച്ചപ്പെടുത്തലിനെ പ്രോത്സാഹിപ്പിക്കുകയും ഭാവിയിലെ വിദ്യാഭ്യാസത്തിനും തൊഴിൽ ജീവിതത്തിനും ശക്തമായ അടിത്തറ ഒരുക്കുകയും ചെയ്യുന്നു."
      ]
    },

    Parent: {
      title: "മാതാപിതാക്കൾക്കായുള്ള PurpleDoor",
      content: [
        "PurpleDoor മാതാപിതാക്കൾക്ക് അവരുടെ കുട്ടികളുടെ പഠനയാത്ര, പങ്കാളിത്തം, നേട്ടങ്ങൾ, സർട്ടിഫിക്കേഷനുകൾ, കഴിവ് വികസന പ്രവർത്തനങ്ങൾ എന്നിവയുടെ വ്യക്തമായ ദൃശ്യാവലോകനം നൽകുന്നു.",
        "മാതാപിതാക്കൾക്ക് നല്ല ശീലങ്ങൾ പ്രോത്സാഹിപ്പിക്കാനും നേട്ടങ്ങൾ ആഘോഷിക്കാനും പുരോഗതി നിരീക്ഷിക്കാനും കുട്ടികളുടെ വ്യക്തിഗത വളർച്ചയെ പിന്തുണയ്ക്കാനും കഴിയും.",
        "AI അധിഷ്ഠിത ഭാവിക്ക് കുട്ടികളെ തയ്യാറാക്കാൻ ഉത്തരവാദിത്വം, ഡിജിറ്റൽ സാക്ഷരത, വിമർശനാത്മക ചിന്ത, സൃഷ്ടിപരത, ജീവിതകാല പഠനം എന്നിവയെ ഈ പ്ലാറ്റ്ഫോം പ്രോത്സാഹിപ്പിക്കുന്നു."
      ]
    },

    LearningPartner: {
      title: "മെന്റർമാർക്കും സ്ഥാപനങ്ങൾക്കുമായി PurpleDoor",
      content: [
        "ഘടനാപരമായ പഠനയാത്രകൾ, ചലഞ്ചുകൾ, സർട്ടിഫിക്കേഷനുകൾ, പ്രോജക്ടുകൾ, കഴിവ് വികസന പരിപാടികൾ എന്നിവയിലൂടെ വിദ്യാർത്ഥികളുടെ വളർച്ചയെ നയിക്കാനും പിന്തുണയ്ക്കാനും PurpleDoor സഹായിക്കുന്നു.",
        "മെന്റർമാർക്കും സ്ഥാപനങ്ങൾക്കും പങ്കാളിത്തം, പുരോഗതി, നേട്ടങ്ങൾ, പഠിതാക്കളുടെ വളർച്ച എന്നിവയെക്കുറിച്ചുള്ള വ്യക്തമായ കാഴ്ചപ്പാട് ലഭിക്കുന്നു.",
        "മാർഗ്ഗനിർദ്ദേശം, ഉത്തരവാദിത്വം, നിർവഹണം, ഭാവി സജ്ജമായ കഴിവ് വികസനം എന്നിവയെ ഒന്നിപ്പിച്ച് അളക്കാവുന്ന സ്വാധീനം സൃഷ്ടിക്കാൻ ഈ പ്ലാറ്റ്ഫോം സഹായിക്കുന്നു."
      ]
    },

    BusinessPartner: {
      title: "കോർഡിനേറ്റർമാർക്കും ഡയറക്ടർമാർക്കും PurpleDoor",
      content: [
        "പഠിതാക്കളുടെ പങ്കാളിത്തം, പ്രോഗ്രാം പ്രകടനം, സർട്ടിഫിക്കേഷനുകൾ, വളർച്ചാ പ്രവണതകൾ, പരിവർത്തന ഫലങ്ങൾ എന്നിവയെക്കുറിച്ചുള്ള പ്രവർത്തനപരവും തന്ത്രപരവുമായ കാഴ്ചപ്പാട് PurpleDoor നൽകുന്നു.",
        "കോർഡിനേറ്റർമാർക്കും ഡയറക്ടർമാർക്കും പ്രവർത്തനങ്ങൾ നിരീക്ഷിക്കാനും പങ്കാളികളെ പിന്തുണയ്ക്കാനും ഫലപ്രാപ്തി വിലയിരുത്താനും മെച്ചപ്പെടുത്തൽ അവസരങ്ങൾ കണ്ടെത്താനും കഴിയും.",
        "ഭാവിയിലെ തൊഴിൽശേഷിയുടെയും സമൂഹ വികസനത്തിന്റെയും ആവശ്യങ്ങളുമായി സംഘടനാ ലക്ഷ്യങ്ങളെ പൊരുത്തപ്പെടുത്തിക്കൊണ്ട് ഡാറ്റ അടിസ്ഥാനമാക്കിയുള്ള തീരുമാനങ്ങൾ എടുക്കാൻ ഈ പ്ലാറ്റ്ഫോം സഹായിക്കുന്നു."
      ]
    }
  },

  pa: {
    General: {
      title: "PurpleDoor ਜਾਣ-ਪਛਾਣ",
      content: [
        "PurpleDoor Gen Z ਅਤੇ Gen Alpha ਸਿੱਖਣ ਵਾਲਿਆਂ ਲਈ ਬਣਾਇਆ ਗਿਆ ਇੱਕ ਵਿਕਾਸ ਅਤੇ ਬਦਲਾਅ ਪਲੇਟਫਾਰਮ ਹੈ, ਜੋ ਸੰਰਚਿਤ ਸਿੱਖਿਆ, ਚੈਲੈਂਜਾਂ, ਸਰਟੀਫਿਕੇਸ਼ਨਾਂ, ਹੁਨਰ ਵਿਕਾਸ ਅਤੇ ਮਾਪਣਯੋਗ ਪ੍ਰਗਤੀ 'ਤੇ ਕੇਂਦ੍ਰਿਤ ਹੈ।",
        "ਇਹ ਪਲੇਟਫਾਰਮ AI-ਚਲਿਤ ਦੁਨੀਆ ਲਈ ਲੋੜੀਂਦੀ ਅਨੁਸ਼ਾਸਨ, ਨਿਰੰਤਰਤਾ, ਕਾਰਜਨਵਿਅਨ, ਡਿਜ਼ਿਟਲ ਸਮਰੱਥਾ ਅਤੇ ਭਵਿੱਖ-ਤਿਆਰ ਹੁਨਰਾਂ ਨੂੰ ਉਤਸ਼ਾਹਿਤ ਕਰਦਾ ਹੈ।",
        "ਵਿਦਿਆਰਥੀ, ਮਾਪੇ, ਮਾਰਗਦਰਸ਼ਕ, ਕੋਆਰਡੀਨੇਟਰ, ਸੰਸਥਾਵਾਂ ਅਤੇ ਲੀਡਰਸ਼ਿਪ ਟੀਮਾਂ ਇੱਕ ਇਕਸਾਰ ਇਕੋਸਿਸਟਮ ਵਿੱਚ ਮਿਲ ਕੇ ਕੰਮ ਕਰਦੀਆਂ ਹਨ।"
      ]
    },

    Student: {
      title: "ਵਿਦਿਆਰਥੀਆਂ ਲਈ PurpleDoor",
      content: [
        "PurpleDoor ਵਿਦਿਆਰਥੀਆਂ ਨੂੰ ਚੈਲੈਂਜਾਂ, ਸਰਟੀਫਿਕੇਸ਼ਨਾਂ, ਪ੍ਰੋਜੈਕਟਾਂ ਅਤੇ ਹੁਨਰ ਵਿਕਾਸ ਗਤੀਵਿਧੀਆਂ ਰਾਹੀਂ ਸਿੱਖਿਆ ਨੂੰ ਕਾਰਵਾਈ ਵਿੱਚ ਬਦਲਣ ਵਿੱਚ ਮਦਦ ਕਰਦਾ ਹੈ।",
        "ਵਿਦਿਆਰਥੀ ਅਨੁਸ਼ਾਸਨ, ਨਿਰੰਤਰਤਾ, ਸੰਚਾਰ, ਰਚਨਾਤਮਕਤਾ, ਨੇਤ੍ਰਿਤਵ, ਸਮੱਸਿਆ ਹੱਲ ਅਤੇ ਡਿਜ਼ਿਟਲ ਹੁਨਰ ਵਿਕਸਿਤ ਕਰ ਸਕਦੇ ਹਨ।",
        "ਇਹ ਪਲੇਟਫਾਰਮ ਪ੍ਰਗਤੀ ਨੂੰ ਸਨਮਾਨਿਤ ਕਰਦਾ ਹੈ ਅਤੇ ਭਵਿੱਖ ਦੀ ਸਿੱਖਿਆ, ਕਰੀਅਰ ਅਤੇ ਉਦਯਮਤਾ ਲਈ ਮਜ਼ਬੂਤ ਨੀਂਹ ਤਿਆਰ ਕਰਦਾ ਹੈ।"
      ]
    },

    Parent: {
      title: "ਮਾਪਿਆਂ ਲਈ PurpleDoor",
      content: [
        "PurpleDoor ਮਾਪਿਆਂ ਨੂੰ ਆਪਣੇ ਬੱਚੇ ਦੀ ਸਿੱਖਣ ਯਾਤਰਾ, ਭਾਗੀਦਾਰੀ, ਪ੍ਰਾਪਤੀਆਂ, ਸਰਟੀਫਿਕੇਸ਼ਨਾਂ ਅਤੇ ਹੁਨਰ ਵਿਕਾਸ ਗਤੀਵਿਧੀਆਂ ਦੀ ਸਪੱਸ਼ਟ ਝਲਕ ਦਿੰਦਾ ਹੈ।",
        "ਮਾਪੇ ਚੰਗੀਆਂ ਆਦਤਾਂ ਨੂੰ ਉਤਸ਼ਾਹਿਤ ਕਰ ਸਕਦੇ ਹਨ, ਪ੍ਰਾਪਤੀਆਂ ਦਾ ਜਸ਼ਨ ਮਨਾ ਸਕਦੇ ਹਨ ਅਤੇ ਲੰਬੇ ਸਮੇਂ ਦੇ ਨਿੱਜੀ ਵਿਕਾਸ ਦਾ ਸਮਰਥਨ ਕਰ ਸਕਦੇ ਹਨ।",
        "ਇਹ ਪਲੇਟਫਾਰਮ ਪਰਿਵਾਰਾਂ ਨੂੰ ਬੱਚਿਆਂ ਨੂੰ AI-ਚਲਿਤ ਭਵਿੱਖ ਲਈ ਤਿਆਰ ਕਰਨ ਵਿੱਚ ਮਦਦ ਕਰਦਾ ਹੈ।"
      ]
    },

    LearningPartner: {
      title: "ਮਾਰਗਦਰਸ਼ਕਾਂ ਅਤੇ ਸੰਸਥਾਵਾਂ ਲਈ PurpleDoor",
      content: [
        "PurpleDoor ਸੰਰਚਿਤ ਸਿੱਖਣ ਯਾਤਰਾਵਾਂ, ਚੈਲੈਂਜਾਂ, ਸਰਟੀਫਿਕੇਸ਼ਨਾਂ ਅਤੇ ਪ੍ਰੋਜੈਕਟਾਂ ਰਾਹੀਂ ਵਿਦਿਆਰਥੀ ਵਿਕਾਸ ਨੂੰ ਮਾਰਗਦਰਸ਼ਨ ਅਤੇ ਸਮਰਥਨ ਦੇਣ ਵਿੱਚ ਮਦਦ ਕਰਦਾ ਹੈ।",
        "ਮਾਰਗਦਰਸ਼ਕ ਅਤੇ ਸੰਸਥਾਵਾਂ ਭਾਗੀਦਾਰੀ, ਪ੍ਰਗਤੀ, ਪ੍ਰਾਪਤੀਆਂ ਅਤੇ ਵਿਕਾਸ ਬਾਰੇ ਵਧੀਆ ਦ੍ਰਿਸ਼ਟੀ ਪ੍ਰਾਪਤ ਕਰਦੇ ਹਨ।",
        "ਇਹ ਪਲੇਟਫਾਰਮ ਮਾਰਗਦਰਸ਼ਨ, ਜ਼ਿੰਮੇਵਾਰੀ ਅਤੇ ਭਵਿੱਖ-ਤਿਆਰ ਹੁਨਰ ਵਿਕਾਸ ਨੂੰ ਜੋੜ ਕੇ ਅਸਲ ਪ੍ਰਭਾਵ ਪੈਦਾ ਕਰਦਾ ਹੈ।"
      ]
    },

    BusinessPartner: {
      title: "ਕੋਆਰਡੀਨੇਟਰਾਂ ਅਤੇ ਡਾਇਰੈਕਟਰਾਂ ਲਈ PurpleDoor",
      content: [
        "PurpleDoor ਸਿੱਖਣ ਵਾਲਿਆਂ ਦੀ ਭਾਗੀਦਾਰੀ, ਪ੍ਰੋਗਰਾਮ ਪ੍ਰਦਰਸ਼ਨ, ਸਰਟੀਫਿਕੇਸ਼ਨਾਂ, ਵਿਕਾਸ ਰੁਝਾਨਾਂ ਅਤੇ ਨਤੀਜਿਆਂ ਬਾਰੇ ਕਾਰਜਕਾਰੀ ਅਤੇ ਰਣਨੀਤਿਕ ਦ੍ਰਿਸ਼ਟੀ ਪ੍ਰਦਾਨ ਕਰਦਾ ਹੈ।",
        "ਕੋਆਰਡੀਨੇਟਰ ਅਤੇ ਡਾਇਰੈਕਟਰ ਗਤੀਵਿਧੀਆਂ ਦੀ ਨਿਗਰਾਨੀ ਕਰ ਸਕਦੇ ਹਨ, ਹਿੱਸੇਦਾਰਾਂ ਦਾ ਸਮਰਥਨ ਕਰ ਸਕਦੇ ਹਨ ਅਤੇ ਸੁਧਾਰ ਦੇ ਮੌਕੇ ਪਛਾਣ ਸਕਦੇ ਹਨ।",
        "ਇਹ ਪਲੇਟਫਾਰਮ ਭਵਿੱਖ ਦੇ ਕਰਮਚਾਰੀ ਬਲ ਅਤੇ ਸਮਾਜਿਕ ਵਿਕਾਸ ਦੀਆਂ ਲੋੜਾਂ ਦੇ ਅਨੁਕੂਲ ਜਾਣਕਾਰੀ-ਅਧਾਰਿਤ ਫ਼ੈਸਲੇ ਲੈਣ ਵਿੱਚ ਮਦਦ ਕਰਦਾ ਹੈ।"
      ]
    }
  },

  as: {
    General: {
      title: "PurpleDoor পৰিচয়",
      content: [
        "PurpleDoor হৈছে Gen Z আৰু Gen Alpha শিক্ষাৰ্থীৰ বাবে ডিজাইন কৰা এক বিকাশ আৰু ৰূপান্তৰ প্লেটফৰ্ম, যি গঠনমূলক শিক্ষণ, চেলেঞ্জ, প্ৰমাণপত্ৰ, দক্ষতা বিকাশ আৰু পৰিমাপযোগ্য অগ্ৰগতি অনুসৰণৰ ওপৰত কেন্দ্ৰিত।",
        "এই প্লেটফৰ্মে AI-চালিত বিশ্বত প্ৰয়োজনীয় শৃংখলা, ধাৰাবাহিকতা, কাৰ্যকৰী দক্ষতা, ডিজিটেল সক্ষমতা আৰু ভৱিষ্যৎ-সাজু দক্ষতাক উৎসাহিত কৰে।",
        "শিক্ষাৰ্থী, অভিভাৱক, মেণ্টৰ, সমন্বয়ক, প্ৰতিষ্ঠান আৰু নেতৃত্বৰ দলসমূহ বাস্তৱ জীৱনৰ ফলাফলৰ ওপৰত কেন্দ্ৰিত এক একত্ৰিত পৰিবেশত একেলগে কাম কৰে।"
      ]
    },

    Student: {
      title: "শিক্ষাৰ্থীৰ বাবে PurpleDoor",
      content: [
        "PurpleDoorয়ে শিক্ষাৰ্থীক চেলেঞ্জ, প্ৰমাণপত্ৰ, প্ৰকল্প, দক্ষতা বিকাশ কাৰ্যকলাপ আৰু সাফল্য অনুসৰণৰ জৰিয়তে শিক্ষাক কাৰ্যত পৰিণত কৰিবলৈ সহায় কৰে।",
        "শিক্ষাৰ্থীসকলে শৃংখলা, ধাৰাবাহিকতা, যোগাযোগ, সৃষ্টিশীলতা, নেতৃত্ব, সমস্যা সমাধান আৰু ডিজিটেল দক্ষতা বিকাশ কৰিব পাৰে।",
        "এই প্লেটফৰ্মে অগ্ৰগতিক স্বীকৃতি দিয়ে, ধাৰাবাহিক উন্নতিক উৎসাহিত কৰে আৰু ভৱিষ্যতৰ শিক্ষা, কেৰিয়াৰ, উদ্যোগিতা আৰু জীৱনজোৰা বিকাশৰ বাবে এক শক্তিশালী ভিত্তি গঢ়ি তোলে।"
      ]
    },

    Parent: {
      title: "অভিভাৱকৰ বাবে PurpleDoor",
      content: [
        "PurpleDoorয়ে অভিভাৱকসকলক তেওঁলোকৰ সন্তানৰ শিক্ষণ যাত্ৰা, অংশগ্ৰহণ, সাফল্য, প্ৰমাণপত্ৰ আৰু দক্ষতা বিকাশ কাৰ্যকলাপৰ এক স্পষ্ট চিত্ৰ প্ৰদান কৰে।",
        "অভিভাৱকসকলে ভাল অভ্যাস উৎসাহিত কৰিব পাৰে, মাইলষ্টোন উদযাপন কৰিব পাৰে, অগ্ৰগতি পৰ্যবেক্ষণ কৰিব পাৰে আৰু পৰম্পৰাগত শিক্ষাৰ বাহিৰেও ব্যক্তিগত বিকাশক সমৰ্থন কৰিব পাৰে।",
        "এই প্লেটফৰ্মে দায়িত্ববোধ, ডিজিটেল সাক্ষৰতা, সমালোচনামূলক চিন্তাধাৰা, সৃষ্টিশীলতা আৰু জীৱনজোৰা শিক্ষণৰ জৰিয়তে পৰিয়ালসমূহক AI-চালিত ভৱিষ্যতৰ বাবে সন্তানসকলক প্ৰস্তুত কৰাত সহায় কৰে।"
      ]
    },

    LearningPartner: {
      title: "মেণ্টৰ আৰু প্ৰতিষ্ঠানৰ বাবে PurpleDoor",
      content: [
        "PurpleDoorয়ে গঠনমূলক শিক্ষণ যাত্ৰা, চেলেঞ্জ, প্ৰমাণপত্ৰ, প্ৰকল্প আৰু দক্ষতা বিকাশ উদ্যোগৰ জৰিয়তে শিক্ষাৰ্থীৰ বিকাশক পথ প্ৰদৰ্শন, সমৰ্থন আৰু ৰূপান্তৰ কৰাত সহায় কৰে।",
        "মেণ্টৰ আৰু প্ৰতিষ্ঠানসমূহে অংশগ্ৰহণ, অগ্ৰগতি, সাফল্য আৰু শিক্ষাৰ্থীৰ বিকাশৰ ওপৰত অধিক দৃশ্যমানতা লাভ কৰে।",
        "এই প্লেটফৰ্মে পথ প্ৰদৰ্শন, জবাবদিহিতা, কাৰ্যকৰী দক্ষতা আৰু ভৱিষ্যৎ-সাজু দক্ষতা বিকাশৰ সমন্বয়ৰ জৰিয়তে পৰিমাপযোগ্য প্ৰভাৱ সৃষ্টি কৰাত সহায় কৰে।"
      ]
    },

    BusinessPartner: {
      title: "সমন্বয়ক আৰু পৰিচালকৰ বাবে PurpleDoor",
      content: [
        "PurpleDoorয়ে শিক্ষাৰ্থীৰ অংশগ্ৰহণ, কাৰ্যসূচীৰ কাৰ্যক্ষমতা, প্ৰমাণপত্ৰ, বিকাশৰ ধাৰা আৰু ৰূপান্তৰৰ ফলাফলৰ ওপৰত পৰিচালনামূলক আৰু কৌশলগত দৃশ্যমানতা প্ৰদান কৰে।",
        "সমন্বয়ক আৰু পৰিচালকসকলে কাৰ্যকলাপ নিৰীক্ষণ কৰিব পাৰে, অংশীদাৰসকলক সমৰ্থন কৰিব পাৰে, কাৰ্যকাৰিতা মূল্যায়ন কৰিব পাৰে আৰু উন্নয়নৰ সুযোগ চিনাক্ত কৰিব পাৰে।",
        "এই প্লেটফৰ্মে ভৱিষ্যতৰ কৰ্মশক্তি আৰু সমাজ বিকাশৰ প্ৰয়োজনীয়তাৰ সৈতে সংগতি ৰাখি তথ্য-ভিত্তিক সিদ্ধান্ত গ্ৰহণত সহায় কৰে।"
      ]
    }
  },

  ur: {
    General: {
      title: "PurpleDoor کا تعارف",
      content: [
        "PurpleDoor Gen Z اور Gen Alpha سیکھنے والوں کے لیے تیار کیا گیا ایک ترقی اور تبدیلی کا پلیٹ فارم ہے، جو منظم تعلیم، چیلنجز، سرٹیفیکیشنز، مہارتوں کی ترقی اور قابلِ پیمائش پیش رفت پر مرکوز ہے۔",
        "یہ پلیٹ فارم AI سے چلنے والی دنیا کے لیے ضروری نظم و ضبط، مستقل مزاجی، عملدرآمد، ڈیجیٹل صلاحیت اور مستقبل کے لیے تیار مہارتوں کو فروغ دیتا ہے۔",
        "طلبہ، والدین، رہنما، کوآرڈینیٹرز، ادارے اور قیادت کی ٹیمیں ایک متحد ماحولیاتی نظام میں حقیقی نتائج کے لیے مل کر کام کرتی ہیں۔"
      ]
    },

    Student: {
      title: "طلبہ کے لیے PurpleDoor",
      content: [
        "PurpleDoor طلبہ کو چیلنجز، سرٹیفیکیشنز، منصوبوں، مہارت سازی کی سرگرمیوں اور کامیابیوں کی ٹریکنگ کے ذریعے سیکھنے کو عمل میں تبدیل کرنے میں مدد دیتا ہے۔",
        "طلبہ نظم و ضبط، مستقل مزاجی، ابلاغ، تخلیقی صلاحیت، قیادت، مسئلہ حل کرنے اور ڈیجیٹل مہارتیں حاصل کر سکتے ہیں۔",
        "یہ پلیٹ فارم پیش رفت کو سراہتا ہے، مسلسل بہتری کی حوصلہ افزائی کرتا ہے اور تعلیم، کیریئر، کاروبار اور زندگی بھر کی ترقی کے لیے مضبوط بنیاد فراہم کرتا ہے۔"
      ]
    },

    Parent: {
      title: "والدین کے لیے PurpleDoor",
      content: [
        "PurpleDoor والدین کو اپنے بچوں کی تعلیمی پیش رفت، شرکت، کامیابیوں، سرٹیفیکیشنز اور مہارت سازی کی سرگرمیوں کا واضح جائزہ فراہم کرتا ہے۔",
        "والدین اچھی عادات کو فروغ دے سکتے ہیں، اہم کامیابیوں کا جشن منا سکتے ہیں اور بچوں کی طویل مدتی ذاتی ترقی میں مدد کر سکتے ہیں۔",
        "یہ پلیٹ فارم خاندانوں کو ذمہ داری، ڈیجیٹل خواندگی، تنقیدی سوچ، تخلیقی صلاحیت اور مسلسل سیکھنے کے ذریعے AI دور کے لیے تیار کرتا ہے۔"
      ]
    },

    LearningPartner: {
      title: "رہنماؤں اور اداروں کے لیے PurpleDoor",
      content: [
        "PurpleDoor منظم تعلیمی سفر، چیلنجز، سرٹیفیکیشنز، منصوبوں اور مہارت سازی کے اقدامات کے ذریعے طلبہ کی ترقی میں رہنمائی اور معاونت فراہم کرتا ہے۔",
        "رہنما اور ادارے طلبہ کی شرکت، پیش رفت، کامیابیوں اور ترقی کے بارے میں بہتر بصیرت حاصل کرتے ہیں۔",
        "یہ پلیٹ فارم رہنمائی، جوابدہی، عملدرآمد اور مستقبل کے لیے تیار مہارتوں کو یکجا کرکے قابلِ پیمائش اثر پیدا کرتا ہے۔"
      ]
    },

    BusinessPartner: {
      title: "کوآرڈینیٹرز اور ڈائریکٹرز کے لیے PurpleDoor",
      content: [
        "PurpleDoor طلبہ کی مصروفیت، پروگرام کی کارکردگی، سرٹیفیکیشنز، ترقی کے رجحانات اور تبدیلی کے نتائج کے بارے میں عملی اور اسٹریٹجک بصیرت فراہم کرتا ہے۔",
        "کوآرڈینیٹرز اور ڈائریکٹرز سرگرمیوں کی نگرانی کر سکتے ہیں، شراکت داروں کی مدد کر سکتے ہیں اور بہتری کے مواقع کی نشاندہی کر سکتے ہیں۔",
        "یہ پلیٹ فارم مستقبل کی افرادی قوت اور سماجی ترقی کی ضروریات کے مطابق باخبر فیصلے کرنے میں مدد دیتا ہے۔"
      ]
    }
  },

  ar: {
    General: {
      title: "نظرة عامة على PurpleDoor",
      content: [
        "PurpleDoor هو منصة للنمو والتحول مصممة لمتعلمي Gen Z وGen Alpha من خلال التعلم المنظم والتحديات والشهادات وتطوير المهارات وتتبع التقدم القابل للقياس.",
        "تعزز المنصة الانضباط والاستمرارية والتنفيذ والقدرات الرقمية والمهارات الجاهزة للمستقبل المطلوبة في عالم تقوده تقنيات الذكاء الاصطناعي.",
        "يعمل الطلاب وأولياء الأمور والمرشدون والمنسقون والمؤسسات وفرق القيادة معًا ضمن منظومة موحدة تركز على النتائج الواقعية."
      ]
    },

    Student: {
      title: "PurpleDoor للطلاب",
      content: [
        "يساعد PurpleDoor الطلاب على تحويل التعلم إلى تطبيق عملي من خلال التحديات والشهادات والمشروعات وأنشطة تطوير المهارات وتتبع الإنجازات.",
        "يمكن للطلاب تطوير الانضباط والاستمرارية والتواصل والإبداع والقيادة وحل المشكلات والمهارات الرقمية التي تتجاوز التعليم التقليدي.",
        "تكافئ المنصة التقدم وتشجع على التحسين المستمر وتساعد المتعلمين على بناء أساس قوي للتعليم المستقبلي والمسارات المهنية وريادة الأعمال والنمو مدى الحياة."
      ]
    },

    Parent: {
      title: "PurpleDoor لأولياء الأمور",
      content: [
        "يوفر PurpleDoor لأولياء الأمور رؤية واضحة لرحلة تعلم أبنائهم ومشاركاتهم وإنجازاتهم وشهاداتهم وأنشطة تطوير المهارات.",
        "يمكن للآباء والأمهات تشجيع العادات الإيجابية والاحتفال بالإنجازات ومتابعة التقدم ودعم النمو الشخصي طويل المدى.",
        "تساعد المنصة الأسر على إعداد أبنائها لمستقبل يقوده الذكاء الاصطناعي من خلال تعزيز المسؤولية والثقافة الرقمية والتفكير النقدي والإبداع والتعلم المستمر."
      ]
    },

    LearningPartner: {
      title: "PurpleDoor للمرشدين والمؤسسات",
      content: [
        "يمكّن PurpleDoor منظومات التعلم من توجيه الطلاب ودعمهم وتطويرهم من خلال مسارات تعليمية منظمة وتحديات وشهادات ومشروعات ومبادرات تطوير المهارات.",
        "يحصل المرشدون والمؤسسات على رؤية أوضح حول المشاركة والتقدم والإنجازات ونمو المتعلمين.",
        "تساعد المنصة على تحقيق تأثير ملموس من خلال الجمع بين التوجيه والمساءلة والتنفيذ وتطوير المهارات الجاهزة للمستقبل."
      ]
    },

    BusinessPartner: {
      title: "PurpleDoor للمنسقين والمديرين",
      content: [
        "يوفر PurpleDoor رؤية تشغيلية واستراتيجية حول مشاركة المتعلمين وأداء البرامج والشهادات واتجاهات النمو ونتائج التحول.",
        "يمكن للمنسقين والمديرين متابعة الأنشطة ودعم أصحاب المصلحة وتقييم الفعالية وتحديد فرص التحسين وضمان التنفيذ الناجح.",
        "تمكّن المنصة من اتخاذ قرارات قائمة على البيانات مع مواءمة الأهداف المؤسسية مع احتياجات القوى العاملة والمجتمع في المستقبل."
      ]
    }
  },

  ja: {
    General: {
      title: "PurpleDoor 概要",
      content: [
        "PurpleDoorは、Gen ZおよびGen Alphaの学習者向けに設計された成長と変革のためのプラットフォームであり、体系的な学習、チャレンジ、認定資格、スキル開発、そして測定可能な進捗管理を提供します。",
        "このプラットフォームは、AI主導の世界で必要とされる規律、一貫性、実行力、デジタル能力、そして未来志向のスキルを育成します。",
        "学生、保護者、メンター、コーディネーター、教育機関、リーダーシップチームが、現実社会での成果を目指して一つのエコシステムの中で協力します。"
      ]
    },

    Student: {
      title: "学生向け PurpleDoor",
      content: [
        "PurpleDoorは、チャレンジ、認定資格、プロジェクト、スキル開発活動、成果の記録を通じて、学びを実践へと変えることを支援します。",
        "学生は、規律、一貫性、コミュニケーション力、創造力、リーダーシップ、問題解決能力、デジタルスキルを身につけることができます。",
        "このプラットフォームは進歩を評価し、継続的な成長を促進し、将来の教育、キャリア、起業、そして生涯にわたる成長のための基盤を築きます。"
      ]
    },

    Parent: {
      title: "保護者向け PurpleDoor",
      content: [
        "PurpleDoorは、子どもの学習状況、参加状況、成果、認定資格、スキル開発活動を保護者が明確に把握できるよう支援します。",
        "保護者は良い習慣を促進し、節目を祝い、進捗を見守りながら、学業以外の長期的な成長も支援できます。",
        "このプラットフォームは、責任感、デジタルリテラシー、批判的思考、創造性、生涯学習を促進し、AI時代に向けた準備を支援します。"
      ]
    },

    LearningPartner: {
      title: "メンター・教育機関向け PurpleDoor",
      content: [
        "PurpleDoorは、体系的な学習プログラム、チャレンジ、認定資格、プロジェクト、スキル開発活動を通じて、学生の成長を支援します。",
        "メンターや教育機関は、参加状況、進捗、成果、学習者の成長について、従来の学業成績を超えた可視化を得ることができます。",
        "このプラットフォームは、指導、責任感、実行力、未来志向のスキル開発を組み合わせ、測定可能な成果を生み出します。"
      ]
    },

    BusinessPartner: {
      title: "コーディネーター・ディレクター向け PurpleDoor",
      content: [
        "PurpleDoorは、学習者の参加状況、プログラム成果、認定資格、成長傾向、変革の成果について、運営面および戦略面での可視化を提供します。",
        "コーディネーターやディレクターは活動を監視し、関係者を支援し、効果を評価し、改善機会を特定できます。",
        "このプラットフォームは、将来の人材育成や社会的ニーズに合わせたデータ主導の意思決定を支援します。"
      ]
    }
  },

  zh: {
    General: {
      title: "PurpleDoor 概览",
      content: [
        "PurpleDoor 是一个专为 Gen Z 和 Gen Alpha 学习者打造的成长与转型平台，提供结构化学习、挑战任务、认证体系、技能培养以及可量化的成长追踪。",
        "该平台致力于培养在 AI 时代所需的自律性、持续性、执行力、数字能力以及面向未来的核心技能。",
        "学生、家长、导师、协调员、教育机构和领导团队共同在统一生态系统中协作，专注于实现真实成果。"
      ]
    },

    Student: {
      title: "面向学生的 PurpleDoor",
      content: [
        "PurpleDoor 通过挑战任务、认证、项目实践、技能培养活动和成就追踪，帮助学生将学习转化为行动。",
        "学生能够培养自律、坚持、沟通能力、创造力、领导力、问题解决能力以及数字技能，超越传统学术教育。",
        "平台鼓励持续进步并认可成长成果，为未来教育、职业发展、创业和终身成长奠定坚实基础。"
      ]
    },

    Parent: {
      title: "面向家长的 PurpleDoor",
      content: [
        "PurpleDoor 为家长提供清晰的视角，了解孩子的学习历程、参与情况、成就、认证以及技能发展活动。",
        "家长能够鼓励良好习惯、庆祝成长里程碑、跟踪进展，并支持孩子在学业之外的长期个人成长。",
        "平台通过培养责任感、数字素养、批判性思维、创造力和终身学习能力，帮助家庭为 AI 驱动的未来做好准备。"
      ]
    },

    LearningPartner: {
      title: "面向导师与机构的 PurpleDoor",
      content: [
        "PurpleDoor 帮助学习生态系统通过结构化学习路径、挑战任务、认证、项目和技能培养计划来引导和支持学生成长。",
        "导师和机构能够全面了解学习者的参与度、进展情况、成就以及成长表现。",
        "平台将指导、责任、执行力和未来技能培养结合起来，创造可衡量的积极影响。"
      ]
    },

    BusinessPartner: {
      title: "面向协调员与主管的 PurpleDoor",
      content: [
        "PurpleDoor 提供关于学习者参与度、项目绩效、认证成果、成长趋势和转型成果的运营与战略视角。",
        "协调员和主管可以监督活动、支持利益相关者、评估项目成效并发现改进机会。",
        "平台支持基于数据的决策制定，同时帮助组织目标与未来人才发展和社会需求保持一致。"
      ]
    }
  },

  ko: {
    General: {
      title: "PurpleDoor 소개",
      content: [
        "PurpleDoor는 Gen Z와 Gen Alpha 학습자를 위해 설계된 성장 및 변화 플랫폼으로, 체계적인 학습, 챌린지, 인증, 역량 개발 및 측정 가능한 성장 추적을 제공합니다.",
        "이 플랫폼은 AI 중심 시대에 필요한 규율, 일관성, 실행력, 디지털 역량 및 미래 대비 기술을 육성합니다.",
        "학생, 학부모, 멘토, 코디네이터, 기관 및 리더십 팀이 하나의 통합 생태계 안에서 실제 성과를 목표로 협력합니다."
      ]
    },

    Student: {
      title: "학생을 위한 PurpleDoor",
      content: [
        "PurpleDoor는 챌린지, 인증, 프로젝트, 역량 개발 활동 및 성취 추적을 통해 학습을 실천으로 전환할 수 있도록 지원합니다.",
        "학생들은 규율, 꾸준함, 의사소통 능력, 창의성, 리더십, 문제 해결 능력 및 디지털 역량을 개발할 수 있습니다.",
        "이 플랫폼은 성장을 인정하고 지속적인 발전을 장려하며 미래 교육, 진로, 창업 및 평생 성장의 기반을 마련합니다."
      ]
    },

    Parent: {
      title: "학부모를 위한 PurpleDoor",
      content: [
        "PurpleDoor는 자녀의 학습 여정, 참여도, 성취, 인증 및 역량 개발 활동을 명확하게 확인할 수 있도록 지원합니다.",
        "학부모는 좋은 습관을 장려하고 성과를 축하하며 진행 상황을 모니터링하고 장기적인 성장을 지원할 수 있습니다.",
        "이 플랫폼은 책임감, 디지털 리터러시, 비판적 사고, 창의성 및 평생 학습을 촉진하여 AI 시대를 준비하도록 돕습니다."
      ]
    },

    LearningPartner: {
      title: "멘토 및 기관을 위한 PurpleDoor",
      content: [
        "PurpleDoor는 체계적인 학습 여정, 챌린지, 인증, 프로젝트 및 역량 개발 프로그램을 통해 학생 성장을 지원합니다.",
        "멘토와 기관은 학습자의 참여도, 진행 상황, 성취 및 성장에 대한 더 깊은 통찰을 얻을 수 있습니다.",
        "이 플랫폼은 지도, 책임감, 실행력 및 미래 역량 개발을 결합하여 측정 가능한 영향을 만들어냅니다."
      ]
    },

    BusinessPartner: {
      title: "코디네이터 및 디렉터를 위한 PurpleDoor",
      content: [
        "PurpleDoor는 학습자 참여도, 프로그램 성과, 인증, 성장 추세 및 변화 성과에 대한 운영 및 전략적 가시성을 제공합니다.",
        "코디네이터와 디렉터는 활동을 모니터링하고 이해관계자를 지원하며 효과를 평가하고 개선 기회를 파악할 수 있습니다.",
        "이 플랫폼은 미래 인재 육성과 사회적 요구에 맞춘 데이터 기반 의사결정을 지원합니다."
      ]
    }
  },

  es: {
    General: {
      title: "Resumen de PurpleDoor",
      content: [
        "PurpleDoor es una plataforma de crecimiento y transformación diseñada para estudiantes de la Generación Z y Generación Alpha mediante aprendizaje estructurado, desafíos, certificaciones, desarrollo de habilidades y seguimiento medible del progreso.",
        "La plataforma fomenta la disciplina, la constancia, la ejecución, las capacidades digitales y las habilidades preparadas para el futuro necesarias en un mundo impulsado por la IA.",
        "Estudiantes, padres, mentores, coordinadores, instituciones y equipos de liderazgo colaboran dentro de un ecosistema unificado enfocado en resultados reales."
      ]
    },

    Student: {
      title: "PurpleDoor para Estudiantes",
      content: [
        "PurpleDoor ayuda a los estudiantes a transformar el aprendizaje en acción mediante desafíos, certificaciones, proyectos, actividades de desarrollo de habilidades y seguimiento de logros.",
        "Los estudiantes pueden desarrollar disciplina, constancia, comunicación, creatividad, liderazgo, resolución de problemas y habilidades digitales más allá de la educación tradicional.",
        "La plataforma recompensa el progreso, fomenta la mejora continua y ayuda a construir una base sólida para la educación futura, las carreras profesionales, el emprendimiento y el crecimiento permanente."
      ]
    },

    Parent: {
      title: "PurpleDoor para Padres",
      content: [
        "PurpleDoor ofrece a los padres una visión clara del recorrido de aprendizaje de sus hijos, su participación, logros, certificaciones y actividades de desarrollo de habilidades.",
        "Los padres pueden fomentar hábitos consistentes, celebrar logros, supervisar el progreso y apoyar el crecimiento personal a largo plazo más allá del rendimiento académico tradicional.",
        "La plataforma ayuda a las familias a preparar a los niños para un futuro impulsado por la IA promoviendo la responsabilidad, la alfabetización digital, el pensamiento crítico, la creatividad y el aprendizaje continuo."
      ]
    },

    LearningPartner: {
      title: "PurpleDoor para Mentores e Instituciones",
      content: [
        "PurpleDoor permite a los ecosistemas educativos guiar, apoyar y transformar el desarrollo estudiantil mediante recorridos de aprendizaje estructurados, desafíos, certificaciones, proyectos e iniciativas de desarrollo de habilidades.",
        "Los mentores e instituciones obtienen visibilidad sobre la participación, el progreso, los logros y el crecimiento de los estudiantes más allá de las métricas académicas tradicionales.",
        "La plataforma ayuda a generar un impacto medible combinando orientación, responsabilidad, ejecución y desarrollo de habilidades preparadas para el futuro."
      ]
    },

    BusinessPartner: {
      title: "PurpleDoor para Coordinadores y Directores",
      content: [
        "PurpleDoor proporciona visibilidad operativa y estratégica sobre la participación de los estudiantes, el rendimiento de los programas, las certificaciones, las tendencias de crecimiento y los resultados de transformación.",
        "Los coordinadores y directores pueden supervisar actividades, apoyar a los participantes, evaluar la eficacia, identificar oportunidades de mejora y garantizar una ejecución exitosa.",
        "La plataforma permite tomar decisiones informadas alineando los objetivos organizacionales con las necesidades futuras de la fuerza laboral y el desarrollo comunitario."
      ]
    }
  },

  pt: {
    General: {
      title: "Visão Geral do PurpleDoor",
      content: [
        "PurpleDoor é uma plataforma de crescimento e transformação criada para alunos da Geração Z e Geração Alpha por meio de aprendizagem estruturada, desafios, certificações, desenvolvimento de competências e acompanhamento mensurável do progresso.",
        "A plataforma incentiva disciplina, consistência, execução, capacidade digital e competências preparadas para o futuro necessárias em um mundo impulsionado por IA.",
        "Estudantes, pais, mentores, coordenadores, instituições e equipes de liderança trabalham juntos em um ecossistema unificado focado em resultados reais."
      ]
    },

    Student: {
      title: "PurpleDoor para Estudantes",
      content: [
        "PurpleDoor ajuda os estudantes a transformar aprendizado em ação por meio de desafios, certificações, projetos, atividades de desenvolvimento de competências e acompanhamento de conquistas.",
        "Os estudantes podem desenvolver disciplina, consistência, comunicação, criatividade, liderança, resolução de problemas e competências digitais além da educação tradicional.",
        "A plataforma recompensa o progresso, incentiva a melhoria contínua e ajuda os alunos a construir uma base sólida para educação futura, carreiras, empreendedorismo e crescimento ao longo da vida."
      ]
    },

    Parent: {
      title: "PurpleDoor para Pais",
      content: [
        "PurpleDoor oferece aos pais uma visão clara da jornada de aprendizagem dos seus filhos, incluindo participação, conquistas, certificações e atividades de desenvolvimento de competências.",
        "Os pais podem incentivar hábitos consistentes, celebrar marcos, acompanhar o progresso e apoiar o crescimento pessoal de longo prazo além do desempenho acadêmico tradicional.",
        "A plataforma ajuda as famílias a preparar as crianças para um futuro impulsionado por IA, promovendo responsabilidade, alfabetização digital, pensamento crítico, criatividade e aprendizagem contínua."
      ]
    },

    LearningPartner: {
      title: "PurpleDoor para Mentores e Instituições",
      content: [
        "PurpleDoor permite que ecossistemas educacionais orientem, apoiem e transformem o desenvolvimento dos estudantes por meio de jornadas estruturadas de aprendizagem, desafios, certificações, projetos e iniciativas de desenvolvimento de competências.",
        "Mentores e instituições obtêm visibilidade sobre participação, progresso, conquistas e crescimento dos estudantes além das métricas acadêmicas tradicionais.",
        "A plataforma ajuda a criar impacto mensurável ao combinar orientação, responsabilidade, execução e desenvolvimento de competências preparadas para o futuro."
      ]
    },

    BusinessPartner: {
      title: "PurpleDoor para Coordenadores e Diretores",
      content: [
        "PurpleDoor fornece visibilidade operacional e estratégica sobre engajamento dos alunos, desempenho dos programas, certificações, tendências de crescimento e resultados de transformação.",
        "Coordenadores e diretores podem monitorar atividades, apoiar participantes, avaliar a eficácia, identificar oportunidades de melhoria e garantir uma execução bem-sucedida.",
        "A plataforma permite decisões orientadas por dados, alinhando objetivos organizacionais às necessidades futuras da força de trabalho e do desenvolvimento comunitário."
      ]
    }
  },

  fr: {
    General: {
      title: "Présentation de PurpleDoor",
      content: [
        "PurpleDoor est une plateforme de croissance et de transformation conçue pour les apprenants de la Génération Z et de la Génération Alpha grâce à un apprentissage structuré, des défis, des certifications, le développement de compétences et un suivi mesurable des progrès.",
        "La plateforme encourage la discipline, la régularité, l'exécution, les capacités numériques et les compétences d'avenir nécessaires dans un monde piloté par l'IA.",
        "Les étudiants, parents, mentors, coordinateurs, institutions et équipes de direction collaborent au sein d'un écosystème unifié axé sur des résultats concrets."
      ]
    },

    Student: {
      title: "PurpleDoor pour les Étudiants",
      content: [
        "PurpleDoor aide les étudiants à transformer l'apprentissage en action grâce à des défis, certifications, projets, activités de développement des compétences et suivi des réalisations.",
        "Les étudiants peuvent développer la discipline, la régularité, la communication, la créativité, le leadership, la résolution de problèmes et les compétences numériques au-delà du cadre académique traditionnel.",
        "La plateforme récompense les progrès, encourage l'amélioration continue et aide les apprenants à construire une base solide pour leurs études futures, leur carrière, l'entrepreneuriat et leur développement personnel à long terme."
      ]
    },

    Parent: {
      title: "PurpleDoor pour les Parents",
      content: [
        "PurpleDoor offre aux parents une vision claire du parcours d'apprentissage de leur enfant, de sa participation, de ses réalisations, de ses certifications et de ses activités de développement des compétences.",
        "Les parents peuvent encourager des habitudes régulières, célébrer les réussites, suivre les progrès et soutenir le développement personnel à long terme au-delà des résultats scolaires traditionnels.",
        "La plateforme aide les familles à préparer les enfants à un avenir dominé par l'IA en favorisant la responsabilité, la culture numérique, l'esprit critique, la créativité et l'apprentissage continu."
      ]
    },

    LearningPartner: {
      title: "PurpleDoor pour les Mentors et les Institutions",
      content: [
        "PurpleDoor permet aux écosystèmes éducatifs de guider, soutenir et transformer le développement des étudiants grâce à des parcours d'apprentissage structurés, des défis, des certifications, des projets et des initiatives de développement des compétences.",
        "Les mentors et les institutions bénéficient d'une visibilité sur la participation, les progrès, les réalisations et l'évolution des apprenants au-delà des indicateurs académiques traditionnels.",
        "La plateforme contribue à créer un impact mesurable en combinant accompagnement, responsabilité, exécution et développement de compétences adaptées à l'avenir."
      ]
    },

    BusinessPartner: {
      title: "PurpleDoor pour les Coordinateurs et les Directeurs",
      content: [
        "PurpleDoor offre une visibilité opérationnelle et stratégique sur l'engagement des apprenants, les performances des programmes, les certifications, les tendances de croissance et les résultats de transformation.",
        "Les coordinateurs et les directeurs peuvent suivre les activités, soutenir les parties prenantes, évaluer l'efficacité, identifier les opportunités d'amélioration et assurer une exécution réussie.",
        "La plateforme favorise une prise de décision éclairée tout en alignant les objectifs organisationnels sur les besoins futurs du marché du travail et du développement communautaire."
      ]
    }
  },

  id: {
    General: {
      title: "Ikhtisar PurpleDoor",
      content: [
        "PurpleDoor adalah platform pertumbuhan dan transformasi yang dirancang untuk pelajar Generasi Z dan Generasi Alpha melalui pembelajaran terstruktur, tantangan, sertifikasi, pengembangan keterampilan, dan pelacakan kemajuan yang terukur.",
        "Platform ini mendorong disiplin, konsistensi, eksekusi, kemampuan digital, dan keterampilan siap masa depan yang dibutuhkan di dunia yang didorong oleh AI.",
        "Siswa, orang tua, mentor, koordinator, institusi, dan tim kepemimpinan bekerja bersama dalam satu ekosistem terpadu yang berfokus pada hasil nyata."
      ]
    },

    Student: {
      title: "PurpleDoor untuk Siswa",
      content: [
        "PurpleDoor membantu siswa mengubah pembelajaran menjadi tindakan melalui tantangan, sertifikasi, proyek, aktivitas pengembangan keterampilan, dan pelacakan pencapaian.",
        "Siswa dapat mengembangkan disiplin, konsistensi, komunikasi, kreativitas, kepemimpinan, pemecahan masalah, dan keterampilan digital yang melampaui pendidikan tradisional.",
        "Platform ini menghargai kemajuan, mendorong perbaikan berkelanjutan, dan membantu peserta didik membangun fondasi yang kuat untuk pendidikan masa depan, karier, kewirausahaan, dan pertumbuhan sepanjang hayat."
      ]
    },

    Parent: {
      title: "PurpleDoor untuk Orang Tua",
      content: [
        "PurpleDoor memberikan gambaran yang jelas kepada orang tua mengenai perjalanan belajar anak mereka, partisipasi, pencapaian, sertifikasi, dan aktivitas pengembangan keterampilan.",
        "Orang tua dapat mendorong kebiasaan yang konsisten, merayakan pencapaian, memantau kemajuan, dan mendukung pertumbuhan pribadi jangka panjang di luar akademik tradisional.",
        "Platform ini membantu keluarga mempersiapkan anak-anak menghadapi masa depan yang didorong oleh AI dengan mempromosikan tanggung jawab, literasi digital, berpikir kritis, kreativitas, dan pembelajaran sepanjang hayat."
      ]
    },

    LearningPartner: {
      title: "PurpleDoor untuk Mentor & Institusi",
      content: [
        "PurpleDoor memungkinkan ekosistem pembelajaran untuk membimbing, mendukung, dan mentransformasi perkembangan siswa melalui perjalanan belajar terstruktur, tantangan, sertifikasi, proyek, dan inisiatif pengembangan keterampilan.",
        "Mentor dan institusi memperoleh visibilitas terhadap partisipasi, kemajuan, pencapaian, dan pertumbuhan peserta didik di luar ukuran akademik tradisional.",
        "Platform ini membantu menciptakan dampak yang terukur dengan menggabungkan bimbingan, akuntabilitas, eksekusi, dan pengembangan keterampilan yang siap menghadapi masa depan."
      ]
    },

    BusinessPartner: {
      title: "PurpleDoor untuk Koordinator & Direktur",
      content: [
        "PurpleDoor menyediakan visibilitas operasional dan strategis terhadap keterlibatan peserta didik, kinerja program, sertifikasi, tren pertumbuhan, dan hasil transformasi.",
        "Koordinator dan direktur dapat memantau aktivitas, mendukung para pemangku kepentingan, mengevaluasi efektivitas, mengidentifikasi peluang perbaikan, dan memastikan pelaksanaan yang sukses.",
        "Platform ini memungkinkan pengambilan keputusan berbasis data sambil menyelaraskan tujuan organisasi dengan kebutuhan tenaga kerja dan pengembangan masyarakat di masa depan."
      ]
    }
  },

  ms: {
    General: {
      title: "Gambaran Keseluruhan PurpleDoor",
      content: [
        "PurpleDoor ialah platform pertumbuhan dan transformasi yang direka untuk pelajar Generasi Z dan Generasi Alpha melalui pembelajaran berstruktur, cabaran, pensijilan, pembangunan kemahiran, dan penjejakan kemajuan yang boleh diukur.",
        "Platform ini menggalakkan disiplin, konsistensi, pelaksanaan, keupayaan digital, dan kemahiran masa depan yang diperlukan dalam dunia yang dipacu AI.",
        "Pelajar, ibu bapa, mentor, penyelaras, institusi, dan pasukan kepimpinan bekerjasama dalam satu ekosistem bersatu yang memberi tumpuan kepada hasil dunia sebenar."
      ]
    },

    Student: {
      title: "PurpleDoor untuk Pelajar",
      content: [
        "PurpleDoor membantu pelajar menukar pembelajaran kepada tindakan melalui cabaran, pensijilan, projek, aktiviti pembangunan kemahiran, dan penjejakan pencapaian.",
        "Pelajar boleh membangunkan disiplin, konsistensi, komunikasi, kreativiti, kepimpinan, penyelesaian masalah, dan kemahiran digital yang melangkaui akademik tradisional.",
        "Platform ini memberi ganjaran kepada kemajuan, menggalakkan penambahbaikan berterusan, dan membantu pelajar membina asas kukuh untuk pendidikan masa depan, kerjaya, keusahawanan, dan pertumbuhan sepanjang hayat."
      ]
    },

    Parent: {
      title: "PurpleDoor untuk Ibu Bapa",
      content: [
        "PurpleDoor memberikan ibu bapa gambaran yang jelas mengenai perjalanan pembelajaran anak mereka, penyertaan, pencapaian, pensijilan, dan aktiviti pembangunan kemahiran.",
        "Ibu bapa boleh menggalakkan tabiat yang konsisten, meraikan pencapaian, memantau kemajuan, dan menyokong pembangunan peribadi jangka panjang melebihi akademik tradisional.",
        "Platform ini membantu keluarga menyediakan anak-anak untuk masa depan yang dipacu AI dengan menggalakkan tanggungjawab, literasi digital, pemikiran kritikal, kreativiti, dan pembelajaran sepanjang hayat."
      ]
    },

    LearningPartner: {
      title: "PurpleDoor untuk Mentor & Institusi",
      content: [
        "PurpleDoor membolehkan ekosistem pembelajaran membimbing, menyokong, dan mentransformasikan pembangunan pelajar melalui perjalanan pembelajaran berstruktur, cabaran, pensijilan, projek, dan inisiatif pembangunan kemahiran.",
        "Mentor dan institusi memperoleh keterlihatan terhadap penyertaan, kemajuan, pencapaian, dan pertumbuhan pelajar melebihi ukuran akademik tradisional.",
        "Platform ini membantu mewujudkan impak yang boleh diukur dengan menggabungkan bimbingan, akauntabiliti, pelaksanaan, dan pembangunan kemahiran masa depan."
      ]
    },

    BusinessPartner: {
      title: "PurpleDoor untuk Penyelaras & Pengarah",
      content: [
        "PurpleDoor menyediakan keterlihatan operasi dan strategik terhadap penglibatan pelajar, prestasi program, pensijilan, trend pertumbuhan, dan hasil transformasi.",
        "Penyelaras dan pengarah boleh memantau aktiviti, menyokong pihak berkepentingan, menilai keberkesanan, mengenal pasti peluang penambahbaikan, dan memastikan pelaksanaan yang berjaya.",
        "Platform ini membolehkan pembuatan keputusan berasaskan data sambil menyelaraskan matlamat organisasi dengan keperluan tenaga kerja dan pembangunan komuniti masa depan."
      ]
    }
  },

  de: {
    General: {
      title: "PurpleDoor Übersicht",
      content: [
        "PurpleDoor ist eine Wachstums- und Transformationsplattform für Lernende der Generation Z und Generation Alpha durch strukturiertes Lernen, Herausforderungen, Zertifizierungen, Kompetenzentwicklung und messbare Fortschrittsverfolgung.",
        "Die Plattform fördert Disziplin, Beständigkeit, Umsetzung, digitale Fähigkeiten und zukunftsorientierte Kompetenzen, die in einer KI-gesteuerten Welt erforderlich sind.",
        "Schüler, Eltern, Mentoren, Koordinatoren, Institutionen und Führungsteams arbeiten in einem gemeinsamen Ökosystem zusammen, das auf reale Ergebnisse ausgerichtet ist."
      ]
    },

    Student: {
      title: "PurpleDoor für Schüler",
      content: [
        "PurpleDoor hilft Schülern, Lernen durch Herausforderungen, Zertifizierungen, Projekte, Kompetenzentwicklungsaktivitäten und Leistungserfassung in Handeln umzusetzen.",
        "Schüler können Disziplin, Beständigkeit, Kommunikation, Kreativität, Führung, Problemlösung und digitale Fähigkeiten entwickeln, die über die traditionelle Bildung hinausgehen.",
        "Die Plattform belohnt Fortschritte, fördert kontinuierliche Verbesserung und hilft Lernenden, eine starke Grundlage für zukünftige Bildung, Karrieren, Unternehmertum und lebenslanges Wachstum aufzubauen."
      ]
    },

    Parent: {
      title: "PurpleDoor für Eltern",
      content: [
        "PurpleDoor bietet Eltern einen klaren Einblick in die Lernreise ihrer Kinder, ihre Teilnahme, Erfolge, Zertifizierungen und Kompetenzentwicklungsaktivitäten.",
        "Eltern können konsequente Gewohnheiten fördern, Meilensteine feiern, Fortschritte verfolgen und langfristiges persönliches Wachstum über traditionelle akademische Leistungen hinaus unterstützen.",
        "Die Plattform hilft Familien, Kinder auf eine KI-getriebene Zukunft vorzubereiten, indem sie Verantwortung, digitale Kompetenz, kritisches Denken, Kreativität und lebenslanges Lernen fördert."
      ]
    },

    LearningPartner: {
      title: "PurpleDoor für Mentoren & Institutionen",
      content: [
        "PurpleDoor ermöglicht Lernökosystemen, die Entwicklung von Schülern durch strukturierte Lernwege, Herausforderungen, Zertifizierungen, Projekte und Kompetenzentwicklungsinitiativen zu begleiten und zu fördern.",
        "Mentoren und Institutionen erhalten Einblicke in Teilnahme, Fortschritt, Erfolge und Wachstum der Lernenden über traditionelle akademische Kennzahlen hinaus.",
        "Die Plattform schafft messbare Wirkung durch die Kombination von Anleitung, Verantwortung, Umsetzung und zukunftsorientierter Kompetenzentwicklung."
      ]
    },

    BusinessPartner: {
      title: "PurpleDoor für Koordinatoren & Direktoren",
      content: [
        "PurpleDoor bietet operative und strategische Transparenz über Lernendenbeteiligung, Programmleistung, Zertifizierungen, Wachstumstrends und Transformationsergebnisse.",
        "Koordinatoren und Direktoren können Aktivitäten überwachen, Beteiligte unterstützen, Wirksamkeit bewerten, Verbesserungsmöglichkeiten erkennen und eine erfolgreiche Umsetzung sicherstellen.",
        "Die Plattform ermöglicht datenbasierte Entscheidungen und richtet organisatorische Ziele an den zukünftigen Anforderungen von Arbeitsmarkt und Gesellschaft aus."
      ]
    }
  },

  tr: {
    General: {
      title: "PurpleDoor Genel Bakış",
      content: [
        "PurpleDoor, yapılandırılmış öğrenme, görevler, sertifikalar, beceri geliştirme ve ölçülebilir ilerleme takibi aracılığıyla Z Kuşağı ve Alfa Kuşağı öğrencileri için tasarlanmış bir büyüme ve dönüşüm platformudur.",
        "Platform, yapay zekâ destekli bir dünyada ihtiyaç duyulan disiplin, tutarlılık, uygulama, dijital yetkinlik ve geleceğe hazır becerileri teşvik eder.",
        "Öğrenciler, ebeveynler, mentorlar, koordinatörler, kurumlar ve liderlik ekipleri gerçek dünya sonuçlarına odaklanan birleşik bir ekosistem içinde birlikte çalışır."
      ]
    },

    Student: {
      title: "Öğrenciler için PurpleDoor",
      content: [
        "PurpleDoor, öğrencilerin öğrenmeyi görevlere, sertifikalara, projelere, beceri geliştirme faaliyetlerine ve başarı takibine dönüştürmesine yardımcı olur.",
        "Öğrenciler disiplin, tutarlılık, iletişim, yaratıcılık, liderlik, problem çözme ve geleneksel eğitimin ötesine geçen dijital beceriler geliştirebilir.",
        "Platform ilerlemeyi ödüllendirir, sürekli gelişimi teşvik eder ve öğrencilerin gelecekteki eğitim, kariyer, girişimcilik ve yaşam boyu gelişim için güçlü bir temel oluşturmasına yardımcı olur."
      ]
    },

    Parent: {
      title: "Ebeveynler için PurpleDoor",
      content: [
        "PurpleDoor, ebeveynlere çocuklarının öğrenme yolculuğu, katılımı, başarıları, sertifikaları ve beceri geliştirme faaliyetleri hakkında net bir görünüm sunar.",
        "Ebeveynler tutarlı alışkanlıkları teşvik edebilir, kilometre taşlarını kutlayabilir, ilerlemeyi takip edebilir ve geleneksel akademik başarının ötesinde uzun vadeli kişisel gelişimi destekleyebilir.",
        "Platform, sorumluluk, dijital okuryazarlık, eleştirel düşünme, yaratıcılık ve yaşam boyu öğrenmeyi teşvik ederek ailelerin çocuklarını yapay zekâ destekli geleceğe hazırlamasına yardımcı olur."
      ]
    },

    LearningPartner: {
      title: "Mentorlar ve Kurumlar için PurpleDoor",
      content: [
        "PurpleDoor, öğrenme ekosistemlerinin öğrencilerin gelişimini yapılandırılmış öğrenme yolculukları, görevler, sertifikalar, projeler ve beceri geliştirme girişimleri aracılığıyla yönlendirmesine ve desteklemesine olanak tanır.",
        "Mentorlar ve kurumlar, geleneksel akademik ölçütlerin ötesinde katılım, ilerleme, başarılar ve öğrenci gelişimi konusunda görünürlük elde eder.",
        "Platform, rehberlik, hesap verebilirlik, uygulama ve geleceğe hazır beceri gelişimini birleştirerek ölçülebilir etki yaratılmasına yardımcı olur."
      ]
    },

    BusinessPartner: {
      title: "Koordinatörler ve Direktörler için PurpleDoor",
      content: [
        "PurpleDoor, öğrenci katılımı, program performansı, sertifikalar, büyüme eğilimleri ve dönüşüm sonuçları hakkında operasyonel ve stratejik görünürlük sağlar.",
        "Koordinatörler ve direktörler faaliyetleri izleyebilir, paydaşları destekleyebilir, etkinliği değerlendirebilir, iyileştirme fırsatlarını belirleyebilir ve başarılı uygulamayı sağlayabilir.",
        "Platform, organizasyonel hedefleri geleceğin iş gücü ve toplumsal gelişim ihtiyaçlarıyla uyumlu hale getirirken veri odaklı karar vermeyi destekler."
      ]
    }
  },
};